<template>
    <div>
        <b-row class="descargarexcel">
            <b-col class="d-flex justify-content-end" style="gap: 8px;">

                <b-button v-if="this.requiereDescarga == true" @click="descargar()" class="boton-busccar botonexcel">
                    <b-icon class="iconoexcel" icon="file-earmark-excel" aria-hidden="true"></b-icon>Descargar

                </b-button>
                <b-button v-if="this.requiereDescargaFormato == true" @click="descargarFormato()" class="boton-busccar botonexcel" variant="success">
                    <b-icon class="iconoexcel" icon="file-earmark-spreadsheet" aria-hidden="true"></b-icon>Reporte
                </b-button>

            </b-col>
        </b-row>
        <b-alert :show="dismissCountDown" dismissible variant="danger" @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            La fecha final no puede ser menor que la fecha inicial
        </b-alert>

        <b-row>
            <b-col>
                <b-form-select @input="TipoCampo()" placeholder="Tipo campo" v-model="filterByColum"
                    :options="optionst"></b-form-select>
            </b-col>
            <b-col v-if="filterByColum == 'id' || filterByColum == 'documento' || filterByColum == 'nombre_completo'">
                <b-input v-model="filter" placeholder="Valor"></b-input>
            </b-col>
            <b-col v-if="filterByColum == 'estado'">
                <b-form-select placeholder="Estado" v-model="filter" :options="optionss"></b-form-select>
            </b-col>
            <b-col v-if="filterByColum == 'departamento'">
                <b-form-select placeholder="Seleccione" v-model="filter" :options="departamentos"></b-form-select>
            </b-col>
            <b-col>
                <b-form-datepicker id="datepicker-dateformat1" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                    v-model="fechainicio" placeholder="Fecha inicial"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="es"></b-form-datepicker>
            </b-col>
            <b-col>
                <b-form-datepicker id="datepicker-dateformat2" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                    v-model="fechafinal" placeholder="Fecha final"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="es"></b-form-datepicker>
            </b-col>
            <b-col v-if="filterByColum != ''">
                <b-button @click="misSolicitudes()" class="boton-busccar">
                    <b-icon class="iconobuscar" icon="search" /> Buscar
                </b-button>
            </b-col>
            <b-col v-if="filterByColum != ''">
                <b-button variant="success" @click="clearfiltros()" class="boton-busccar">
                    Limpiar
                </b-button>
            </b-col>
        </b-row>

        <b-table responsive v-if="items.length > 0 && esperandoInfo != true" :tbody-tr-class="rowClass" id="my-tablems"
            head-variant="light" striped :items="items" :fields="fields">
            <template #cell(N°Solicitud)="row">
                <div>
                    <span>{{ row.item['N°Solicitud'] }}</span>
                    <!-- Indicador si es una solicitud dividida (padre) -->
                    <b-badge v-if="row.item.estado === 17 && row.item.solicitudes_derivadas && row.item.solicitudes_derivadas.length > 0" 
                        variant="warning" 
                        class="ml-2"
                        :id="'badge-dividida-' + row.item.id">
                        <b-icon icon="arrow-right-circle"></b-icon> {{ row.item.solicitudes_derivadas.length }}
                    </b-badge>
                    <b-tooltip v-if="row.item.estado === 17 && row.item.solicitudes_derivadas && row.item.solicitudes_derivadas.length > 0"
                        :target="'badge-dividida-' + row.item.id" 
                        triggers="hover">
                        Dividida en {{ row.item.solicitudes_derivadas.length }} solicitudes: {{ row.item.solicitudes_derivadas.join(', ') }}
                    </b-tooltip>
                    <!-- Indicador si es una división (hijo) -->
                    <b-badge v-if="row.item.solicitud_origen" 
                        variant="info" 
                        class="ml-2"
                        :id="'badge-origen-' + row.item.id">
                        <b-icon icon="arrow-left-circle"></b-icon> #{{ row.item.solicitud_origen }}
                    </b-badge>
                    <b-tooltip v-if="row.item.solicitud_origen"
                        :target="'badge-origen-' + row.item.id" 
                        triggers="hover">
                        División de la solicitud original #{{ row.item.solicitud_origen }}
                    </b-tooltip>
                </div>
            </template>
            <template #cell(Ciudad)="row">
                <div class="departs">
                    <p>{{ row.item.Ciudad }}</p>
                </div>
            </template>
            <template #cell(Departamento)="row">
                <div class="departs">
                    <p>{{ row.item.Departamento }}</p>
                </div>
            </template>
            <template #cell(Acciones)="row">
                <b-row class="acciones">
                    <b-col>
                        <b-button id="tooltip-target-1" variant="info"
                            @click="verOpciones(row.item.id, row.item, row.index, items, cliente = cliente, editar = editar, proveerdor = proveerdor, carpeta = carpeta)"><b-icon
                                class="iconobuscar" icon="eye" /></b-button>
                        <b-tooltip target="tooltip-target-1" triggers="hover" placement="right">
                            Ver más
                        </b-tooltip>
                    </b-col>
                    <!-- <b-col>
                        <b-button id="tooltip-target-2" variant="success" @click="verModal(row.item.id, row.item)"><b-icon
                                class="iconobuscar" icon="newspaper" /></b-button>
                        <b-tooltip target="tooltip-target-2" triggers="hover">
                            Historial
                        </b-tooltip>
                    </b-col> -->
                    <b-col v-if="opcionGestionar == true && permisoGestion !== false">

                        <b-button :disabled="carpeta === 'Proveedores' && (row.item.estado == 7 || row.item.estado == 13)" id="tooltip-target-3" variant="primary"
                            @click="seguimientos(row.item.id, row.item.estado, row.item)"><b-icon class="iconobuscar"
                                icon="check-circle" /></b-button>

                        <b-tooltip target="tooltip-target-3" triggers="hover"  placement="right" >

                            Gestionar

                        </b-tooltip>

                    </b-col>
                    <b-col v-if="opcionRetiro == true && permisoRetiro !== false">

                        <b-button :disabled="row.item.estado == 9 || row.item.estado == 13 || row.item.estado == 14 || row.item.estado == 15 || (estadosPermitidosRetiro !== null && estadosPermitidosRetiro !== undefined && !estadosPermitidosRetiro.includes(row.item.estado))" id="tooltip-target-3" variant="primary"
                            @click="seguimientos(row.item.id, row.item.estado, row.item)"><b-icon class="iconobuscar"
                                icon="check-circle" /></b-button>

                        <b-tooltip target="tooltip-target-3" triggers="hover">

                            Solicitud retiro

                        </b-tooltip>

                    </b-col>
                    <b-col v-if="opcionAsignar == true">
                        <span v-if="bloqueos[row.item.id]">
                            <b-button
                                :id="'tooltip-bloqueado-' + row.item.id"
                                variant="secondary"
                                disabled>
                                <b-icon class="iconobuscar" icon="lock-fill" />
                            </b-button>
                            <b-tooltip :target="'tooltip-bloqueado-' + row.item.id" triggers="hover" placement="right">
                                En edición por: {{ bloqueos[row.item.id].nombre_usuario }}
                            </b-tooltip>
                        </span>
                        <span v-else>
                            <b-button :id="'tooltip-asignar-' + row.item.id" variant="primary" @click="asignacion(row.item.id)">
                                <b-icon class="iconobuscar" icon="check-circle" />
                            </b-button>
                            <b-tooltip :target="'tooltip-asignar-' + row.item.id" triggers="hover" placement="right">
                                Asignar
                            </b-tooltip>
                        </span>
                    </b-col>
                    <b-col v-if="opcionRetirar == true">

                        <b-button :id="'tooltip-retirar-' + row.item.id" variant="danger" :disabled="row.item.estado != 1 && row.item.estado != 2" @click="retirar(row.item.id, row.item.estado)"><b-icon
                                class="iconobuscar" icon="x-circle" /></b-button>

                        <b-tooltip :target="'tooltip-retirar-' + row.item.id" triggers="hover"  placement="right">

                            {{ row.item.estado == 1 || row.item.estado == 2 ? 'Retirar' : 'Solo se puede retirar en estado Nuevo o Devuelto' }}

                        </b-tooltip>

                    </b-col>
                    <b-col v-if="opcionRetiroProveedor == true">

                        <b-button id="tooltip-target-retiro-proveedor" variant="success" 
                            @click="gestionarRetiroProveedor(row.item.id, row.item.estado, row.item)"><b-icon
                                class="iconobuscar" icon="check-circle-fill" /></b-button>

                        <b-tooltip target="tooltip-target-retiro-proveedor" triggers="hover" placement="right">

                            Gestionar Retiro

                        </b-tooltip>

                    </b-col>
                    <b-col v-if="opcionDividir == true">

                        <b-button :disabled="row.item.estado != 1 && row.item.estado != 2" 
                            :id="'tooltip-dividir-' + row.item.id" 
                            variant="warning" 
                            @click="abrirModalDividir(row.item)">
                            <b-icon class="iconobuscar" icon="scissors" />
                        </b-button>

                        <b-tooltip :target="'tooltip-dividir-' + row.item.id" triggers="hover" placement="right">
                            {{ row.item.estado == 1 || row.item.estado == 2 ? 'Dividir solicitud' : 'Solo se puede dividir en estado Nuevo o Devuelto' }}
                        </b-tooltip>

                    </b-col>
                    <b-col v-if="opcionRechazar == true">

                        <b-button :disabled="carpeta === 'Proveedores' && (row.item.estado == 7 || row.item.estado == 13)" id="tooltip-target-4" variant="danger" @click="rechazar(row.item.id)"><b-icon
                                class="iconobuscar" icon="x-circle" /></b-button>

                        <b-tooltip target="tooltip-target-4" triggers="hover"  placement="right">

                            Rechazar

                        </b-tooltip>

                    </b-col>
                    <b-col v-if="opcionAutorizar == true">

                        <b-button :id="'tooltip-autorizar-' + row.item.id" variant="success" @click="autorizarSolicitud(row.item)"><b-icon
                                class="iconobuscar" icon="shield-check" /></b-button>

                        <b-tooltip :target="'tooltip-autorizar-' + row.item.id" triggers="hover" placement="right">

                            Registrar Autorización

                        </b-tooltip>

                    </b-col>
                </b-row>
            </template>
        </b-table>
        <div class="spinerr" v-if="esperandoInfo == true">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <div class="divnodata" v-if="totalfilas == 0 && esperandoInfo != true">
            <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
            <p>No se encontró información</p>

        </div>
        <b-row>
            <b-col class="nombrelabel" md="2" offset-md="9">
                <label for="selectPage">Registros por página:</label>
            </b-col>
            <b-col md="1">
                <b-form-select class="selectpage" @input="paginacion(currentPage = 1)" v-model="perPageInternal"
                    :options="pageOptions" />
            </b-col>
        </b-row>
        <b-pagination class="justify-content-center" v-model="currentPage" :total-rows="totalfilas" :per-page="perPageInternal"
            @input="paginacion(currentPage)" aria-controls="my-tablems"></b-pagination>

        <b-modal size="xl" hide-footer centered class="modalSolicitudes" dialog-class="modal-historico-estados" ref="modal-1" title="Histórico de estados" header-close-label="Cerrar">
            <b-alert :show="dismissCountDown1" dismissible variant="danger" @dismissed="dismissCountDown1 = 0"
                @dismiss-count-down="showAlert">
                La fecha final no puede ser menor que la fecha inicial
            </b-alert>
            <b-row class="rowhistorial">
                <b-col> <b-form-select placeholder="Tipo campo" v-model="filterByColum1"
                        :options="optionsdos"></b-form-select></b-col>
                <b-col v-if="filterByColum1 == 'observaciones'"> <b-input placeholder="Valor"
                        v-model="filter1"></b-input></b-col>
                <b-col v-if="filterByColum1 == 'estado'"> <b-form-select placeholder="Estado" v-model="filter1"
                        :options="optionss"></b-form-select></b-col>
                <b-col>

                    <b-form-datepicker id="ex-disabled-readonly" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                        v-model="fechainicio1" placeholder="Fecha inicial"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="es"></b-form-datepicker>

                </b-col>

                <b-col>

                    <b-form-datepicker id="ex-disabled-readonly1" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                        v-model="fechafinal1" placeholder="Fecha final"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="es"></b-form-datepicker>

                </b-col>

                <b-col v-if="filterByColum1 != 'Seleccionar una opción'">
                    <b-button @click="verModal(idSolicitud, datoactual)" class="boton-busccar">
                        <b-icon class="iconobuscar" icon="search" /> Buscar
                    </b-button>
                </b-col>
            </b-row>
            
            <!-- Selector de items por página e indicador de resultados -->
            <b-row class="mt-3 mb-3" v-if="esperandoEstados == false && totalfilasestados > 0">
                <b-col cols="6">
                    <label for="perPageSelectEstados">Mostrar:</label>
                    <b-form-select 
                        id="perPageSelectEstados"
                        v-model="perPagedos" 
                        :options="[5, 10, 15, 20, 25, 50]"
                        @change="cambiarItemsPorPaginaEstados"
                        style="width: auto; display: inline-block; margin-left: 10px;">
                    </b-form-select>
                    <span style="margin-left: 10px;">registros por página</span>
                </b-col>
                <b-col cols="6" class="text-right">
                    <span>Mostrando {{ (currentPagedos - 1) * perPagedos + 1 }} - {{ Math.min(currentPagedos * perPagedos, totalfilasestados) }} de {{ totalfilasestados }} resultados</span>
                </b-col>
            </b-row>
            
            <div class="spinerr" v-if="esperandoEstados == true">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-table v-if="esperandoEstados == false" head-variant="light" striped id="my-table2"
                :items="itemsdos" :fields="fieldsdos" style="width:100%; table-layout: fixed;">
                <template #cell(Archivos)="row">
                     <b-button  v-if="!viewArchivos"  id="tooltip-target-1"  variant="info"
                            @click="VisualizarArchivos(row)"><b-icon
                                class="iconobuscar" icon="file-earmark" /></b-button>
                </template>
            </b-table>
            <div class="divnodata" v-if="totalfilasestados == undefined && esperandoEstados == false">
                <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
                <p>No se encontró información</p>
            </div>
            <b-pagination @input="paginacionestados(currentPagedos)" class="justify-content-center" v-model="currentPagedos"
                :total-rows="totalfilasestados" :per-page="perPagedos" aria-controls="my-table2"></b-pagination>
        </b-modal>
        
        <!-- Modal para Historial de Modificaciones -->
        <b-modal size="xl" hide-footer centered class="modalSolicitudes" dialog-class="modal-historico-estados" ref="modal-modificaciones" title="Historial de Modificaciones" header-close-label="Cerrar">
            <b-alert :show="dismissCountDown1" dismissible variant="danger" @dismissed="dismissCountDown1 = 0"
                @dismiss-count-down="showAlert">
                La fecha final no puede ser menor que la fecha inicial
            </b-alert>
            <b-row class="rowhistorial">
                <b-col> 
                    <b-input placeholder="Buscar en observaciones" v-model="filterModificaciones"></b-input>
                </b-col>
                <b-col>
                    <b-form-datepicker id="ex-disabled-readonly-mod-inicio" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                        v-model="fechainicioModificaciones" placeholder="Fecha inicial"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="es"></b-form-datepicker>
                </b-col>
                <b-col>
                    <b-form-datepicker id="ex-disabled-readonly-mod-final" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                        v-model="fechafinalModificaciones" placeholder="Fecha final"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="es"></b-form-datepicker>
                </b-col>
                <b-col>
                    <b-button @click="verHistorialModificaciones(idSolicitud, datoactual)" class="boton-busccar">
                        <b-icon class="iconobuscar" icon="search" /> Buscar
                    </b-button>
                </b-col>
            </b-row>
            <b-table head-variant="light" striped :per-page="perPageModificaciones" :current-page="currentPageModificaciones" 
                id="my-table-modificaciones" :items="itemsModificaciones" :fields="fieldsModificaciones">
            </b-table>
            <div class="divnodata" v-if="totalfilasModificaciones == undefined || totalfilasModificaciones == 0">
                <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
                <p>No se encontró información</p>
            </div>
            <b-pagination @input="paginacionModificaciones(currentPageModificaciones)" class="justify-content-center" 
                v-model="currentPageModificaciones" :total-rows="totalfilasModificaciones" :per-page="perPageModificaciones" 
                aria-controls="my-table-modificaciones"></b-pagination>
        </b-modal>

        <b-modal hide-footer ref="archivoModal" centered title="Archivos cargados" header-close-label="Cerrar">
        <div v-if="cantidadImg.length > 0 ">
            <b-badge
                v-for="(imageUrl, index) in cantidadImg"
                :key="index"
                class="badge-dismissible b-imagenss ml-5"
                variant="info"
                @click="verArchivos(imageUrl)">
                <img width="70" src="https://icones.pro/wp-content/uploads/2021/06/icone-fichier-document-vert.png" >
               <p class="letraImage"
                style="font-size: 12px; margin-top: 5px; margin-bottom: 0; width: 195px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                {{ imageUrl.name }}
                </p>
            </b-badge>
        </div>
        <div class="divnodata" v-else>
          <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
                <p>No se encontró información</p>
        </div>
    </b-modal>
        <b-modal size="xl" hide-footer centered class="modalSolicitudes " ref="modal-2" :title="titulomodal" header-close-label="Cerrar">
            <div v-if="this.requiereGestionar == true" class="chequeo sg">
                <input class="form-check-input checsg" type="checkbox" v-model="gestionar" name="checkbox-1">
                <div class="recordarr poppins-normal-tuatara-14px letrasg">Tomar solicitud</div>
            </div>
            <div v-if="this.requiereIntentoEntrega == true" class="chequeo sg">
                <input class="form-check-input checsg" type="checkbox" v-model="intento" name="checkbox-1">
                <div class="recordarr poppins-normal-tuatara-14px letrasg">Proceso de entrega</div>
            </div>
            <input
                          id="file"
                          ref="file"
                          type="file"
                          class="mt-1 mb-3"
                          name="file"
                          multiple
                          @change="handleFile"
                           accept="image/*, application/pdf"
                        />
              <!-- <b-form-group label="Adjuntar archivo (opcional)" label-cols-sm="6" label-size="sm">
                    <b-form-file v-model="file2" class="mt-3" plain></b-form-file>
                </b-form-group> -->
            <b-form-group label="Notas adicionales" label-for="name-input" invalid-feedback="Name is required">
                <b-form-textarea id="textarea" v-model="notaadicional" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
            
            <b-row>
                <b-col cols="3" offset-md="5">
                    <b-button :disabled="gestionar != true && botonmodal == 'Gestionar'" @click="gestion(idSolicitud)"
                        class="boton-busccar guardarsg">
                        {{ botonmodal }}</b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal centered hide-footer class="modalSolicitudes " ref="modal-3" title="Asignación de solicitud" header-close-label="Cerrar">
            <div class="chequeo sg">
                <div class="recordarr poppins-normal-tuatara-14px letrasgmodal2">La solicitud ha sido asignada a su
                    proveedor. La podrá visualizar y gestionar en la sección "Mis solicitudes".</div>
            </div>
            <b-row>
                <b-col cols="3" offset-md="5">
                    <b-button @click="hideModal()" class="boton-busccar guardarsg">
                        Aceptar</b-button>
                </b-col>
            </b-row>
        </b-modal>
            <b-modal centered hide-footer class="modalSolicitudes" ref="modal-4" title="Cancelar solicitud" header-close-label="Cerrar">
            <div class="chequeo sg">
                <div class="recordarr poppins-normal-tuatara-14px letrasgmodal2">¿Deseas cancelar la solicitud?</div>
            </div>
            <div class="recordarr poppins-normal-tuatara-14px letrasgmodal2">Motivo de cancelación</div>
            <b-form-select placeholder="Motivo" v-model="motivo" :options="motivos"></b-form-select>
            
            
            <b-input class="listamotivo" v-if="this.motivo == 4" placeholder="Motivo" v-model="detallemotivo"></b-input>
             <input
                          id="file"
                          ref="file"
                          type="file"
                          class="mt-1 mb-3"
                          name="file"
                          multiple
                          @change="handleFile"
                           accept="image/*, application/pdf"
                        />
              <!-- <b-form-group label="Adjuntar archivo (opcional)" label-cols-sm="6" label-size="sm">
                    <b-form-file v-model="file2" class="mt-3" plain></b-form-file>
                    
                </b-form-group> -->
            <b-form-group label="Notas adicionales" label-for="name-input" invalid-feedback="Name is required">
                <b-form-textarea id="textarea" v-model="notaadicional" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
            
            <b-row>
                <b-col cols="3" offset-md="5">
                    <b-button @click="hideModall()" class="boton-busccar guardarsg">Aceptar</b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal centered hide-footer class="modalSolicitudes " ref="modal-5" title="¿Deseas rechazar la solicitud ?" header-close-label="Cerrar">
            <div class="chequeo sg">
                <div class="recordarr poppins-normal-tuatara-14px letrasgmodal2">Motivo de rechazo</div>
                <div>
                    <b-form-select placeholder="Motivo" v-model="motivo" :options="motivos"></b-form-select>
                    <b-input class="listamotivo" v-if="this.motivo == 4" placeholder="Motivo"
                        v-model="detallemotivo"></b-input>
                </div>
                   <b-form-group label="Adjuntar archivo (opcional)" label-cols-sm="6" label-size="sm">
                   <input
                          id="file"
                          ref="file"
                          type="file"
                          class="mt-1 mb-3"
                          name="file"
                          multiple
                          @change="handleFile"
                           accept="image/*, application/pdf"
                        />
                    <!-- <b-form-file v-model="file2" class="mt-3" plain></b-form-file> -->
                </b-form-group>
                <b-form-group label="Notas adicionales" label-for="name-input" invalid-feedback="Name is required">
                <b-form-textarea id="textarea" v-model="notaadicional" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
            </div>
            <b-row v-if="this.rechazadaXProveedor == false">
                <b-col cols="3" offset-md="5">
                    <b-button :disabled="motivo == null || motivo == ''" @click="rechazado()"
                        class="boton-busccar guardarsg aceptarrechazo"> Aceptar</b-button>
                </b-col>
            </b-row>
            <b-row v-else>
                <b-col cols="3" offset-md="5">
                    <b-button :disabled="motivo == null || motivo == ''" @click="devolucion()"
                        class="boton-busccar guardarsg aceptarrechazo"> Aceptar</b-button>
                </b-col>
            </b-row>

        </b-modal>
        <b-modal centered hide-footer class="modalSolicitudes " ref="modal-6" title="Asignación de solicitud" header-close-label="Cerrar" @hide="onCerrarModalAsignacion">
            <b-form-group label="Seleccionar una de las siguientes opciones:" label-for="name-input"
                invalid-feedback="Name is required">
                <b-form-group  v-slot="{ ariaDescribedby }">
                    <b-row class="opcionesasignar">
                    <!-- <b-col class="chequeo sg">
                        <b-form-radio plain  name="radio-inline" value="false"  v-model="Aprovedor">   <div class="recordarr poppins-normal-tuatara-14px letrasg">Asignación general</div></b-form-radio>
                    </b-col> -->
                    <b-col class="chequeo sg">
                        <b-form-radio plain name="radio-inline"  value="true"   v-model="Aprovedor"> <div class="recordarr poppins-normal-tuatara-14px letrasg">Asignación específica</div></b-form-radio>
                    </b-col>
                </b-row>
                </b-form-group>
                <div v-if="Aprovedor == 'true'" class="opcionesprove">
                    <b-form-select placeholder="Seleccionar proveedor" requiered v-model="proveedorId"
                        :options="proveedores" @change="consultarDisponibilidadProveedor"></b-form-select>
                        <b-alert :show="showDismissibleAlert" variant="danger" class="alerts" dismissible>
                       Campo obligatorio</b-alert>
                </div>
                
                <!-- Selector de fecha para consultar disponibilidad -->
                <div v-if="Aprovedor == 'true' && proveedorId" class="mt-3">
                    <b-form-group label="Seleccionar fecha para consultar disponibilidad:" label-for="fecha-disponibilidad">
                        <b-form-datepicker 
                            id="fecha-disponibilidad"
                            v-model="fechaConsultaDisponibilidad" 
                            placeholder="Seleccionar fecha"
                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                            locale="es"
                            @input="consultarDisponibilidadProveedor">
                        </b-form-datepicker>
                    </b-form-group>
                </div>

                <!-- Mostrar equipos disponibles -->
                <div v-if="Aprovedor == 'true' && proveedorId && fechaConsultaDisponibilidad && equiposDisponibles" class="mt-3">
                    <b-card header="Equipos Disponibles" header-bg-variant="primary" header-text-variant="white">
                        <b-alert v-if="!equiposDisponibles || equiposDisponibles.length === 0" show variant="warning">
                            No hay disponibilidad registrada para este proveedor en la fecha seleccionada.
                        </b-alert>
                        
                        <!-- Mostrar información de múltiples sedes -->
                        <div v-else-if="equiposDisponibles.length > 0">
                            <!-- Filtro por sede (opcional) -->
                            <b-form-group 
                                v-if="sedesDisponiblesTodas.length > 1" 
                                label="Filtrar por sede:" 
                                label-for="filtro-sede"
                                class="mb-3">
                                <b-form-select 
                                    id="filtro-sede"
                                    v-model="sedeSeleccionada"
                                    @change="aplicarFiltroSede">
                                    <b-form-select-option :value="null">Todas las sedes ({{ sedesDisponiblesTodas.length }})</b-form-select-option>
                                    <b-form-select-option 
                                        v-for="sede in sedesDisponiblesTodas" 
                                        :key="sede" 
                                        :value="sede">
                                        {{ sede }}
                                    </b-form-select-option>
                                </b-form-select>
                            </b-form-group>
                            
                            <!-- Indicador de múltiples sedes -->
                            <b-alert show variant="info" class="mb-3" v-if="equiposDisponiblesSinFiltrar.length > 1">
                                <i class="fas fa-info-circle"></i> Se encontraron <strong>{{ equiposDisponiblesSinFiltrar.length }}</strong> sede(s) con disponibilidad para este proveedor
                                <span v-if="sedeSeleccionada"> (mostrando <strong>{{ equiposDisponiblesFiltrados.length }}</strong> filtrada(s))</span>
                            </b-alert>
                            
                            <!-- Acordeón para mostrar múltiples sedes -->
                            <div role="tablist">
                                <b-card v-for="(equipo, index) in equiposDisponiblesFiltrados" :key="generarIdUnicoSede(equipo)" no-body class="mb-2">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button 
                                            block 
                                            v-b-toggle="'accordion-' + generarIdUnicoSede(equipo)" 
                                            variant="light" 
                                            class="text-left p-3">
                                            <strong>{{ equipo.sede_de_equipos || 'Sede no especificada' }}</strong> 
                                            <span class="float-right">
                                                <b-badge variant="success">Día: {{ equipo.total_dia || 0 }}</b-badge>
                                                <b-badge variant="info" class="ml-1">Noche: {{ equipo.total_noche || 0 }}</b-badge>
                                            </span>
                                        </b-button>
                                    </b-card-header>
                                    <b-collapse :id="'accordion-' + generarIdUnicoSede(equipo)" role="tabpanel">
                                        <b-card-body>
                                            <p class="mb-2"><strong>Proveedor:</strong> {{ equipo.nombre_proveedor }}</p>
                                        <p class="mb-2"><strong>Regional:</strong> {{ equipo.regional || 'No especificada' }}</p>
                                        <p class="mb-2"><strong>Sede:</strong> {{ equipo.sede_de_equipos || 'No especificada' }}</p>
                                        <p class="mb-3" v-if="equipo.observacion"><strong>Observaciones:</strong> {{ equipo.observacion }}</p>
                                        
                                        <hr>
                                        
                                        <!-- Concentradores -->
                                        <h6 class="text-primary mb-2">🔹 Concentradores</h6>
                                        <b-row class="mb-2">
                                            <b-col cols="6">
                                                <small><strong>Bajo Flujo:</strong></small>
                                                <div>Día: {{ equipo.conc_bajo_flujo_dia || 0 }} | Noche: {{ equipo.conc_bajo_flujo_noche || 0 }}</div>
                                            </b-col>
                                            <b-col cols="6">
                                                <small><strong>Alto Flujo:</strong></small>
                                                <div>Día: {{ equipo.conc_alto_flujo_dia || 0 }} | Noche: {{ equipo.conc_alto_flujo_noche || 0 }}</div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mb-3">
                                            <b-col cols="6">
                                                <small><strong>Portátil:</strong></small>
                                                <div>Día: {{ equipo.conc_portatil_dia || 0 }} | Noche: {{ equipo.conc_portatil_noche || 0 }}</div>
                                            </b-col>
                                        </b-row>
                                        
                                        <!-- Equipos Médicos -->
                                        <h6 class="text-primary mb-2">🔹 Equipos Médicos</h6>
                                        <b-row class="mb-2">
                                            <b-col cols="6">
                                                <small><strong>Aspirador:</strong></small>
                                                <div>Día: {{ equipo.aspirador_dia || 0 }} | Noche: {{ equipo.aspirador_noche || 0 }}</div>
                                            </b-col>
                                            <b-col cols="6">
                                                <small><strong>Nebulizador:</strong></small>
                                                <div>Día: {{ equipo.nebulizador_dia || 0 }} | Noche: {{ equipo.nebulizador_noche || 0 }}</div>
                                            </b-col>
                                        </b-row>
                                        
                                        <!-- Oxímetros -->
                                        <h6 class="text-primary mb-2">🔹 Oxímetros</h6>
                                        <b-row class="mb-2">
                                            <b-col cols="6">
                                                <small><strong>Adulto:</strong></small>
                                                <div>Día: {{ equipo.oximetro_adul_dia || 0 }} | Noche: {{ equipo.oximetro_adul_noche || 0 }}</div>
                                            </b-col>
                                            <b-col cols="6">
                                                <small><strong>Pediátrico:</strong></small>
                                                <div>Día: {{ equipo.oximetro_ped_dia || 0 }} | Noche: {{ equipo.oximetro_ped_noche || 0 }}</div>
                                            </b-col>
                                        </b-row>
                                        
                                        <!-- Otros Equipos -->
                                        <h6 class="text-primary mb-2">🔹 Otros Equipos</h6>
                                        <b-row class="mb-2">
                                            <b-col cols="6">
                                                <small><strong>Bala Portátil:</strong></small>
                                                <div>Día: {{ equipo.bala_portatil_dia || 0 }} | Noche: {{ equipo.bala_portatil_noche || 0 }}</div>
                                            </b-col>
                                            <b-col cols="6">
                                                <small><strong>Regulador Ahorrador:</strong></small>
                                                <div>Día: {{ equipo.regulador_ahorrador_dia || 0 }} | Noche: {{ equipo.regulador_ahorrador_noche || 0 }}</div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mb-2">
                                            <b-col cols="6">
                                                <small><strong>Paquete Pediátrico:</strong></small>
                                                <div>Día: {{ equipo.paquete_pediatrico_dia || 0 }} | Noche: {{ equipo.paquete_pediatrico_noche || 0 }}</div>
                                            </b-col>
                                        </b-row>
                                        
                                        <hr>
                                        
                                        <!-- Totales -->
                                        <b-row>
                                            <b-col cols="6">
                                                <strong>Total Día:</strong> <b-badge variant="success">{{ equipo.total_dia || 0 }}</b-badge>
                                            </b-col>
                                            <b-col cols="6">
                                                <strong>Total Noche:</strong> <b-badge variant="info">{{ equipo.total_noche || 0 }}</b-badge>
                                            </b-col>
                                        </b-row>
                                    </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </b-card>
                </div>
            </b-form-group>
            
            <input
                          id="file"
                          ref="file"
                          type="file"
                        class="mt-1 mb-3"
                          name="file"
                          multiple
                          @change="handleFile"
                          accept="image/*, application/pdf"
                        />
                    <!-- <b-form-group label="Adjuntar archivo (opcional)" label-cols-sm="6" label-size="sm">
                    <b-form-file v-model="file2" class="mt-3" plain></b-form-file>
                </b-form-group> -->
            <b-form-group label="Notas adicionales" label-for="name-input" invalid-feedback="Name is required">
                <b-form-textarea id="textarea" v-model="notaadicional" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
            <b-row>
                <b-col cols="3" offset-md="5">
                <b-button v-if="(proveedorId == null || proveedorId == '') && Aprovedor == 'true'" 
                      @click="showDismissibleAlert=true" class="boton-busccar guardarsg">
                        {{ botonmodal }}</b-button>
                    <b-button
                    v-else
                        @click="Asignarsolicitud(idSolicitud)" class="boton-busccar guardarsg">
                        {{ botonmodal }}</b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal centered hide-footer class="modalSolicitudes " ref="modal-7" title="Gestionar" header-close-label="Cerrar">
            <b-form-group label="Seleccionar una de las siguientes opciones:" label-for="name-input"
                invalid-feedback="Name is required">
                <b-form-group  v-slot="{ ariaDescribedby }">
                    <b-row class="opcionesasignar">
                    <b-col class="chequeo sg">
                        <b-form-radio plain  name="radio-inline" value="true"  v-model="estadoActivo">  <div class="recordarr poppins-normal-tuatara-14px letrasg">Pasar a estado “Entregado”</div></b-form-radio>
                    </b-col>
                    <b-col  v-if="estadoSd === 6"  class="chequeo sg">
                        <b-form-radio plain name="radio-inline"  value="false"   v-model="estadoActivo"> <div class="recordarr poppins-normal-tuatara-14px letrasg">Pasar a estado “Fallo de entrega”</div></b-form-radio>
                    </b-col>
                    <b-col v-if="estadoSd === 8" class="chequeo sg">
                        <b-form-radio plain name="radio-inline"  value="false"   v-model="estadoActivo"> <div class="recordarr poppins-normal-tuatara-14px letrasg">Pasar a estado “Segundo intento de entrega”</div></b-form-radio>
                    </b-col>
                     <b-col v-if="estadoSd === 12" class="chequeo sg">
                        <b-form-radio plain name="radio-inline"  value="false"   v-model="estadoActivo"> <div class="recordarr poppins-normal-tuatara-14px letrasg">Devolver pedido</div></b-form-radio>
                    </b-col>
                </b-row>
                </b-form-group>
            </b-form-group>
            <b-form-group label="Fecha y hora:" label-for="fecha-hora-gestion">
                <b class="obligatorio">*</b>
                <b-form-input
                    id="fecha-hora-gestion"
                    v-model="fechaAsignada"
                    type="datetime-local"
                    :min="getFechaSolicitudDateTime()"
                    :max="getCurrentDateTime()"
                    required
                    placeholder="Seleccionar fecha y hora">
                </b-form-input>
            </b-form-group>
                <b-form-group label-for="file">
                    <template #label>
                        Adjuntar archivo<span v-if="estadoActivo === 'true'" style="color:red;"> * (obligatorio)</span><span v-else> (opcional)</span>:
                    </template>
                    <input
                              id="file"
                              ref="file"
                              type="file"
                             class="mt-1 mb-3"
                              name="file"
                              multiple
                              @change="handleFile"
                              accept="image/*, application/pdf"
                            />
                </b-form-group>
            <b-form-group label="Notas adicionales" label-for="name-input" invalid-feedback="Name is required">
                <b-form-textarea id="textarea" v-model="notaadicional" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
            <b-row>
                <b-col cols="3" offset-md="5">
                    <b-button
                        :disabled="!fechaAsignada || (estadoActivo === 'true' && (!files || files.length === 0))"
                        @click="CambioEstado(idSolicitud)" class="boton-busccar guardarsg">
                        {{ botonmodal }}</b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal centered hide-footer class="modalSolicitudes " ref="modal-8" title="Solicitud de retiro" header-close-label="Cerrar">
           
            <b-form-group label="Seleccionar la fecha y hora de retiro de los elementos de Oxígeno:" label-for="fecha-hora-retiro">
                <b class="obligatorio">*</b>
                <b-form-input
                    id="fecha-hora-retiro"
                    v-model="fecharetiro"
                    type="datetime-local"
                    :min="getMinDateTime()"
                    required
                    placeholder="Seleccionar fecha y hora">
                </b-form-input>
            </b-form-group>

            <!-- Selección de elementos a retirar -->
            <b-form-group label="Elementos a retirar:" v-if="elementosDisponiblesRetiro.length > 0">
                <b-alert show variant="info" class="py-2 px-3 mb-2" style="font-size:0.9em;">
                    Seleccione los elementos que se deben retirar de esta solicitud
                </b-alert>
                <b-form-checkbox
                    v-for="elem in elementosDisponiblesRetiro"
                    :key="elem.id + '_' + elem.tipo"
                    v-model="elementosRetiro"
                    :value="elem"
                    class="mb-1">
                    <b-badge variant="secondary" class="mr-1">{{ elem.tipo }}</b-badge> {{ elem.nombre }}
                </b-form-checkbox>
            </b-form-group>

            <input
                          id="file"
                          ref="file"
                          type="file"
                          class="mt-1 mb-3"
                          name="file"
                          multiple
                          @change="handleFile"
                           accept="image/*, application/pdf"
                        />
  <!-- <b-form-group label="Adjuntar archivo (opcional)" label-cols-sm="6" label-size="sm">
                    <b-form-file v-model="file2" class="mt-3" plain></b-form-file>
                </b-form-group> -->
            <b-form-group label="Notas adicionales" label-for="name-input" invalid-feedback="Name is required">
                <b-form-textarea id="textarea" v-model="notaadicional" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
            <b-row>
                <b-col cols="3" offset-md="5">
                    <b-button :disabled="!fecharetiro" @click="CambioEstado(idSolicitud)"
                        class="boton-busccar guardarsg">
                        {{ botonmodal }}</b-button>
                </b-col>
            </b-row>
        </b-modal>

        <!-- Modal principal para gestión de retiro por proveedor con opciones -->
        <b-modal centered hide-footer class="modalSolicitudes" ref="modal-retiro-proveedor" title="Gestión de Retiro" header-close-label="Cerrar">

            <!-- Elementos solicitados para retiro -->
            <b-card
                v-if="itemRetiroGestion && itemRetiroGestion.elementos_retiro && itemRetiroGestion.elementos_retiro.length > 0"
                class="mb-3"
                border-variant="warning"
                header-bg-variant="warning"
                header-text-variant="dark">
                <template #header>
                    <strong>Elementos solicitados para retiro</strong>
                </template>
                <b-badge
                    v-for="(elem, i) in itemRetiroGestion.elementos_retiro"
                    :key="i"
                    variant="warning"
                    class="mr-1 mb-1 p-2"
                    style="color: #212529;">
                    {{ elem.nombre }} <small>({{ elem.tipo }})</small>
                </b-badge>
            </b-card>

            <b-form-group label="Seleccionar una de las siguientes opciones:" label-for="name-input">
                <p class="text-muted" v-if="estadoActualRetiro === 9">
                    Estado actual: <strong>Solicitud de retiro</strong>
                </p>
                <p class="text-muted" v-if="estadoActualRetiro === 14">
                    Estado actual: <strong>En proceso de retiro</strong>
                </p>
                <p class="text-muted" v-if="estadoActualRetiro === 15">
                    Estado actual: <strong>Retiro fallido</strong>
                </p>
                <p class="text-muted" v-if="estadoActualRetiro === 16">
                    Estado actual: <strong>Retiro parcial</strong> — quedan elementos pendientes de retiro
                </p>
                <b-form-group v-slot="{ ariaDescribedby }">
                    <b-row class="opcionesasignar">
                        <!-- Opción: En proceso de retiro - Solo disponible desde estado 9, 15 o 16 -->
                        <b-col class="chequeo sg" v-if="estadoActualRetiro === 9 || estadoActualRetiro === 15 || estadoActualRetiro === 16">
                            <b-form-radio plain name="radio-retiro" value="proceso" v-model="opcionRetiroSeleccionada">
                                <div class="recordarr poppins-normal-tuatara-14px letrasg">Marcar como "En proceso de retiro"</div>
                            </b-form-radio>
                        </b-col>
                        <!-- Opción: Retiro fallido - Solo disponible desde estado 14 -->
                        <b-col class="chequeo sg" v-if="estadoActualRetiro === 14">
                            <b-form-radio plain name="radio-retiro" value="fallido" v-model="opcionRetiroSeleccionada">
                                <div class="recordarr poppins-normal-tuatara-14px letrasg">Marcar como "Retiro fallido"</div>
                            </b-form-radio>
                        </b-col>
                        <!-- Opción: Retirado - Solo disponible desde estado 14 -->
                        <b-col class="chequeo sg" v-if="estadoActualRetiro === 14">
                            <b-form-radio plain name="radio-retiro" value="retirado" v-model="opcionRetiroSeleccionada">
                                <div class="recordarr poppins-normal-tuatara-14px letrasg">Marcar como "Retirado"</div>
                            </b-form-radio>
                        </b-col>
                    </b-row>
                </b-form-group>
            </b-form-group>

            <!-- Información contextual según la opción seleccionada -->
            <b-alert show variant="info" v-if="opcionRetiroSeleccionada === 'proceso'">
                Esta acción cambiará el estado a <strong>"En proceso de retiro"</strong>. Use esta opción cuando el proveedor haya iniciado el proceso de retiro de los equipos.
            </b-alert>
            <b-alert show variant="warning" v-if="opcionRetiroSeleccionada === 'fallido'">
                Esta acción cambiará el estado a <strong>"Retiro fallido"</strong>. Use esta opción cuando no se haya podido completar el retiro de los equipos.
            </b-alert>
            <b-alert show variant="success" v-if="opcionRetiroSeleccionada === 'retirado'">
                Esta acción registrará el retiro. Si se retiraron <strong>todos</strong> los elementos el estado pasará a <strong>"Retirado"</strong>; si fue solo una parte, quedará en <strong>"Retiro parcial"</strong> y el prestador podrá solicitar el retiro de los elementos restantes.
            </b-alert>
            
            <b-form-group label="Fecha y hora:" label-for="fecha-hora-retiro-gestion" v-if="opcionRetiroSeleccionada">
                <b class="obligatorio">*</b>
                <b-form-input
                    id="fecha-hora-retiro-gestion"
                    v-model="fechaRetiroGestion"
                    type="datetime-local"
                    :max="getCurrentDateTime()"
                    required
                    placeholder="Seleccionar fecha y hora">
                </b-form-input>
            </b-form-group>

            <b-form-group label="Adjuntar evidencia (opcional):" label-for="file-retiro-gestion" v-if="opcionRetiroSeleccionada">
                <input
                    id="file-retiro-gestion"
                    ref="fileRetiroGestion"
                    type="file"
                    class="mt-1 mb-3"
                    name="file"
                    multiple
                    @change="handleFile"
                    accept="image/*, application/pdf"
                />
            </b-form-group>

            <b-form-group label="Observaciones:" label-for="observaciones-retiro-gestion" v-if="opcionRetiroSeleccionada">
                <b-form-textarea 
                    id="observaciones-retiro-gestion" 
                    v-model="notaadicional" 
                    rows="3" 
                    max-rows="6"
                    placeholder="Ingrese cualquier observación sobre la gestión del retiro...">
                </b-form-textarea>
            </b-form-group>

            <b-row v-if="opcionRetiroSeleccionada">
                <b-col cols="4" offset-md="2">
                    <b-button 
                        @click="cerrarModalRetiroProveedor()" 
                        class="boton-busccar" 
                        variant="secondary">
                        Cancelar
                    </b-button>
                </b-col>
                <b-col cols="4">
                    <b-button 
                        :disabled="!fechaRetiroGestion || !opcionRetiroSeleccionada || loadingRetiroProveedor" 
                        @click="procesarRetiroProveedor(idSolicitud)" 
                        class="boton-busccar guardarsg"
                        :variant="getVariantBotonRetiro()">
                        <b-spinner small v-if="loadingRetiroProveedor"></b-spinner>
                        {{ loadingRetiroProveedor ? 'Procesando...' : 'Confirmar' }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal centered hide-footer class="modalSolicitudes " ref="modal-9" title="Visualizar" header-close-label="Cerrar" @hide="onCerrarModalDetalle">
            <b-row class="centrar">
                <b-col cols="3"> 
                    <b-button @click="verDocumento(indexrow, itemrow, cliente, editar, proveerdor, carpeta)" 
                        class="botonopciones" variant="outline-primary"> 
                        <b-icon icon="eye" class="iconoopcione"></b-icon> <br>Detalle solicitud
                    </b-button>
                </b-col>
                <b-col cols="3"> 
                    <b-button @click="verModal(idSolicitud, datoactual)" 
                        class="botonopciones" variant="outline-success"> 
                        <b-icon icon="newspaper" class="iconoopcione"></b-icon><br>Historial estados
                    </b-button>
                </b-col>
                <b-col cols="3"> 
                    <b-button @click="verHistorialModificaciones(idSolicitud, datoactual)" 
                        class="botonopciones" variant="outline-info"> 
                        <b-icon icon="clock-history" class="iconoopcione"></b-icon><br>Historial modificación
                    </b-button>
                </b-col>
                <b-col v-if="this.requierehistorialv" cols="3"> 
                    <b-button @click="verhistorialValoracion(idSolicitud, datoactual)" 
                        class="botonopciones" variant="outline-warning"> 
                        <b-icon icon="building" class="iconoopcione"></b-icon><br>Historial valoración
                    </b-button>
                </b-col>
                <b-col v-if="this.requierecambiov && this.fechaRO == '' && permisoCambioValoracion !== false" cols="3">
                    <b-button @click="cambioValoracion(idSolicitud, datoactual)" 
                        class="botonopciones" variant="outline-danger">
                        <b-icon icon="calendar2-date-fill" class="iconoopcione"></b-icon><br>Fecha valoración
                    </b-button>
                </b-col>
                <b-col v-if="opcionRetirar == true && datoactual && datoactual.estado == 2" cols="3"> 
                    <b-button @click="corregirYReenviar(indexrow, itemrow, carpeta)" 
                        class="botonopciones" variant="outline-warning"> 
                        <b-icon icon="pencil-square" class="iconoopcione"></b-icon><br>Corregir y reenviar
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal centered hide-footer class="modalSolicitudes " ref="modal-10" title="Fecha valoración" header-close-label="Cerrar">
            <b-form-group label="Seleccionar la nueva fecha de valoración:" label-for="name-input"
                invalid-feedback="Name is required">

                <div class="opcionesretiro">
                    <b-form-datepicker :hide-header="true" :label-help="labelhelp" :min="maxDateretiro"
                        v-model="fechavaloracionasas" placeholder="Seleccionar fecha"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="es"></b-form-datepicker>
                </div>
            </b-form-group>
            <input
                          id="file"
                          ref="file"
                          type="file"
                          class="mt-1 mb-3"
                          name="file"
                          multiple
                          @change="handleFile"
                           accept="image/*, application/pdf"
                        />
  <!-- <b-form-group label="Adjuntar archivo (opcional)" label-cols-sm="6" label-size="sm">
                    <b-form-file v-model="file2" class="mt-3" plain></b-form-file>
                </b-form-group> -->
            <b-form-group label="Notas adicionales" label-for="name-input" invalid-feedback="Name is required">
                <b-form-textarea id="textarea" v-model="notaadicional" rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
            <b-row>
                <b-col cols="3" offset-md="5">
                    <b-button :disabled="fechavaloracionasas == null || fechavaloracionasas == ''"
                        @click="CambioFechaValoracion(idSolicitud)" class="boton-busccar guardarsg">
                        {{ botonmodal }}</b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal size="xl" hide-footer centered class="modalSolicitudes" ref="modal-11"
            title="Histórico de fechas de validación" header-close-label="Cerrar">
            <b-row class="rowhistorial">
                <b-col> <b-form-select placeholder="Tipo campo" v-model="filterByColum1"
                        :options="optionsdos"></b-form-select></b-col>
                <b-col v-if="filterByColum1 == 'observaciones'"> <b-input placeholder="Valor"
                        v-model="filter1"></b-input></b-col>
                <b-col v-if="filterByColum1 == 'estado'"> <b-form-select placeholder="Estado" v-model="filter1"
                        :options="optionss"></b-form-select></b-col>
                <b-col>

                    <b-form-datepicker id="ex-disabled-readonly" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                        v-model="fechainicio1" placeholder="Fecha inicial"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="es"></b-form-datepicker>

                </b-col>

                <b-col>

                    <b-form-datepicker id="ex-disabled-readonly1" :hide-header="true" :label-help="labelhelp" :max="maxDate"
                        v-model="fechafinal1" placeholder="Fecha final"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        locale="es"></b-form-datepicker>

                </b-col>

                <b-col v-if="filterByColum1 != 'Seleccionar una opción'">
                    <b-button @click="verhistorialValoracion(idSolicitud, datoactual)" class="boton-busccar">
                        <b-icon class="iconobuscar" icon="search" /> Buscar
                    </b-button>
                </b-col>
            </b-row>
            <b-table head-variant="light" striped :per-page="perPagedos" :current-page="currentPagedos" id="my-table2"
                :items="itemsValoracion" :fields="fieldsdosvalor">

            </b-table>
            <div class="divnodata" v-if="totalfilasestados == undefined">
                <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
                <p>No se encontró información</p>
            </div>
            <b-pagination @input="paginacionestadosv(currentPagedos)" class="justify-content-center"
                v-model="currentPagedos" :total-rows="rowsdos" :per-page="perPagedos"
                aria-controls="my-table2"></b-pagination>
        </b-modal>

        <!-- Modal para dividir solicitud -->
        <b-modal 
            size="xl" 
            ref="modal-dividir" 
            title="Dividir Solicitud" 
            header-close-label="Cerrar"
            @hidden="cerrarModalDividir"
            @ok="dividirSolicitud">
            
            <div v-if="solicitudADividir">
                <b-alert show variant="info">
                    <strong>Solicitud #{{ solicitudADividir.id }}</strong><br>
                    Puede dividir esta solicitud en múltiples solicitudes distribuyendo los elementos entre ellas.
                </b-alert>
                
                <b-alert show variant="primary">
                    <b-icon icon="info-circle-fill"></b-icon>
                    <strong>Importante:</strong> La <strong>División 1</strong> actualizará la solicitud original con los elementos seleccionados. 
                    Las <strong>divisiones adicionales</strong> crearán nuevas solicitudes independientes.
                </b-alert>

                <b-alert v-if="errorDivision" show variant="danger">
                    {{ errorDivision }}
                </b-alert>

                <div class="mb-3">
                    <h5>Elementos disponibles:</h5>
                    <b-badge v-if="elementosSolicitud.length === 0 && elementosInstitucionSolicitud.length === 0" variant="warning">
                        Esta solicitud no tiene elementos asignados
                    </b-badge>
                    <div v-if="elementosSolicitud.length > 0">
                        <strong>Elementos de domicilio:</strong>
                        <ul>
                            <li v-for="(elem, idx) in elementosSolicitud" :key="'dom-' + idx">
                                {{ elem.nombre || elem.id || 'Elemento ' + (idx + 1) }}
                            </li>
                        </ul>
                    </div>
                    <div v-if="elementosInstitucionSolicitud.length > 0">
                        <strong>Elementos de institución:</strong>
                        <ul>
                            <li v-for="(elem, idx) in elementosInstitucionSolicitud" :key="'inst-' + idx">
                                {{ elem.nombre || elem.id || 'Elemento ' + (idx + 1) }}
                            </li>
                        </ul>
                    </div>
                </div>

                <b-button variant="success" size="sm" @click="agregarDivision" class="mb-3">
                    <b-icon icon="plus-circle"></b-icon> Agregar nueva solicitud
                </b-button>

                <div v-for="(division, idx) in divisiones" :key="'div-' + idx" class="mb-4 p-3 border rounded" :class="{ 'border-primary': idx === 0 }">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="mb-0">
                            {{ division.nombre }}
                            <b-badge v-if="idx === 0" variant="primary" class="ml-2">Original</b-badge>
                            <b-badge v-else variant="success" class="ml-2">Nueva</b-badge>
                        </h5>
                        <b-button 
                            v-if="divisiones.length > 1" 
                            variant="danger" 
                            size="sm" 
                            @click="eliminarDivision(idx)">
                            <b-icon icon="trash"></b-icon>
                        </b-button>
                    </div>

                    <div v-if="elementosSolicitud.length > 0" class="mb-3">
                        <label><strong>Elementos de domicilio:</strong></label>
                        <b-form-checkbox-group
                            v-model="division.elementos"
                            :options="getOpcionesElementos(elementosSolicitud)"
                            stacked>
                        </b-form-checkbox-group>
                    </div>

                    <div v-if="elementosInstitucionSolicitud.length > 0">
                        <label><strong>Elementos de institución:</strong></label>
                        <b-form-checkbox-group
                            v-model="division.elementos_institucion"
                            :options="getOpcionesElementos(elementosInstitucionSolicitud)"
                            stacked>
                        </b-form-checkbox-group>
                    </div>

                    <b-badge v-if="division.elementos.length === 0 && division.elementos_institucion.length === 0" variant="warning">
                        Esta división no tiene elementos asignados
                    </b-badge>
                </div>
            </div>

            <template #modal-footer="{ ok, cancel }">
                <b-button variant="secondary" @click="cancel()" :disabled="procesandoDivision">
                    Cancelar
                </b-button>
                <b-button 
                    variant="primary" 
                    @click="ok()" 
                    :disabled="!validarDivisiones() || procesandoDivision">
                    <b-spinner small v-if="procesandoDivision"></b-spinner>
                    {{ procesandoDivision ? 'Procesando...' : 'Dividir solicitud' }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { RepositoryFactory } from "../repositories/RepositoryFactory";
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import Swal from 'sweetalert2'
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";
import * as XLSX from 'xlsx';

Vue.use(VueFormGenerator)

const config = RepositoryFactory.get("config");
const clientes = RepositoryFactory.get("clientes");
const disponibilidad = RepositoryFactory.get("disponibilidad");
export default {
    components: {
        "vue-form-generator": VueFormGenerator.component
    },
    props: [
        "optionst",
        "optionss",
        "fields",
        "requiereListas",
        "requiereDescarga",
        "condicionFiltrao",
        "cliente",
        "editar",
        "proveerdor",
        "opcionRetirar",
        "opcionGestionar",
        "requiereGestionar",
        "titulomodal",
        "botonmodal",
        "requiereBotongestionar",
        "opcionRechazar",
        "condicionales",
        "carpeta",
        "datosExcel",
        "opcionAsignar",
        "typeOrder",
        "sortColumn",
        "requiereIntentoEntrega",
        "rechazadaXProveedor",
        "opcionRetiro",
        "opcionRetiroProveedor",
        "rowClass",
        "requierehistorialv",
        "requierecambiov",
        "permisoRetiro",
        "permisoGestion",
        "permisoCambioValoracion",
        "perPage",
        "opcionDividir",
        // Cuando se define, el botón de retiro solo aparece en las filas con esos estados
        "estadosPermitidosRetiro",
        "requiereDescargaFormato",
        "nombreEntidadCustom",
        "opcionAutorizar",
        "requiereAutorizar",
    ],
    data() {
        return {
            entidadArchivo:"",
             cantidadImg: 0,
            itemsValoracion:null,
            tiempoRM: null,
            fechaRO: null,
            viewArchivos: false,
            files:null,
            bloqueos: {},
            proveedorId: null,
            fechaConsultaDisponibilidad: null,
            equiposDisponibles: [], // Todos los equipos de la API
            equiposDisponiblesSinFiltrar: [], // Respaldo de todos los equipos
            sedeSeleccionada: null, // Para filtrar por sede específica
            estadoActivo: 'true',
            intento: false,
            estadoValidacion: false,
            esperandoInfo: false,
            esperandoEstados: false,
            detallemotivo: "",
            dismissSecs: 5,
        dismissCountDown: 0,
            Ageneral: false,
            Aprovedor: 'false',
            condicionInicial: this.condicionales,
            gestionar: false,
            dismissSecs: 5,
            dismissCountDown: 0,
            showDismissibleAlert:false,
            dismissCountDown1: 0,
            labelhelp: "Utilice las teclas del cursor para navegar por las fechas del calendario",
            maxDate: this.getToday(),
            maxDateretiro: this.getToday(),
            perPageInternal: this.perPage || 5,
            pageOptions: [3, 5, 10, 15, 20, 50, 100, 200, { value: 99999, text: 'Todos' }],
            currentPage: 1,
            perPagedos: 5,
            currentPagedos: 1,
            totalfilas: null,
            totalfilasestados: null,
            idVersion: 2,
            nombreEntidad: this.nombreEntidadCustom || "entidad_solicitud",
            nombreEntidad1: "entidad_solicitud_log",
            column: this.sortColumn || "id",
            column2: "createat",
            notaadicional: "",
            filter: "",
            filter1: "",
            dateBy: "createat",
            fechainicio: "",
            fechafinal: "",
            fechainicio1: "",
            fecharetiro: null,
            fechaRetiroEfectivo: null,
            fechaRetiroGestion: null,
            opcionRetiroSeleccionada: null,
            estadoActualRetiro: null,
            loadingRetiroProveedor: false,
            solicitudActualItem: null,
            elementosRetiro: [],
            itemRetiroGestion: null,
            valoreselementos: [],
            valoreseps: [],
            valorescobertura: [],
            valoresafiliacion: [],
            valoresmediosadmin: [],
            valorescie10: [],
            fechaAsignada :"",
            fechavaloracionasas: null,
            fechafinal1: "",
            selected: null,
            selectedd: null,
            filterByColum: null,
            departamento: null,
            filterByColum1: null,
            departamentos: [{ value: null, text: 'Seleccionar' },],
            optionsdos: [
                { value: null, text: 'Seleccionar' },
                { value: 'observaciones', text: 'Observación' },
                { value: 'estado', text: 'Estado' }
            ],
            endDate: "",
            fieldsdos: [
                { key: 'Fecha',            label: 'Fecha',            thStyle: { width: '10%' } },
                { key: 'Estado',           label: 'Estado',           thStyle: { width: '10%' } },
                { key: 'Actor',            label: 'Actor',            thStyle: { width: '8%'  } },
                { key: 'Realizado por',    label: 'Realizado Por',    thStyle: { width: '8%' } },
                { key: 'Tiempo respuesta', label: 'Tiempo Respuesta', thStyle: { width: '10%' } },
                { key: 'Motivo rechazo',   label: 'Motivo Rechazo',   thStyle: { width: '11%' } },
                { key: 'Detalle motivo',   label: 'Detalle Motivo',   thStyle: { width: '11%' } },
                { key: 'Observación',      label: 'Observación',      thStyle: { width: '25%' } },
                { key: 'Archivos',         label: 'Archivos',         thStyle: { width: '7%'  } },
            ],
            fieldsdosvalor: ['Fecha', 'Observación'],
            itemsdos: [{ isActive: true, Fecha: '26-10-2023', Actor:'Juana','Tiempo en responder':'2 horas',Estado: 'Nuevo', 'Observación': 'Esto es una prueba' },
            { isActive: true, Fecha: '26-10-2023', Estado: 'Nuevo', 'Observación': 'Esto es una prueba' },
            { isActive: true, Fecha: '26-10-2023', Estado: 'Nuevo', 'Observación': 'Esto es una prueba' },
            ],
            // Variables para el modal de Historial de Modificaciones
            fieldsModificaciones: ['Fecha', 'Columnas Modificadas', 'Usuario'],
            itemsModificaciones: [],
            currentPageModificaciones: 1,
            perPageModificaciones: 5,
            totalfilasModificaciones: null,
            filterByColumModificaciones: null,
            filterModificaciones: "",
            fechainicioModificaciones: "",
            fechafinalModificaciones: "",
            items: [],
            table: [],
            // Variables para dividir solicitud
            modalDividirVisible: false,
            procesandoDivision: false, // Prevenir múltiples clics
            solicitudADividir: null,
            elementosSolicitud: [],
            elementosInstitucionSolicitud: [],
            divisiones: [
                { nombre: 'Solicitud 1', elementos: [], elementos_institucion: [] }
            ],
            errorDivision: '',
            motivo: null,
            motivos: { value: null, text: 'Seleccionar' },
            motivosProveedor: [],
            motivosPrestador: [],
            motivosInstitucion: [],
            proveedores: [{ value: null, text: 'Seleccionar' }],
            retiraropcion: false,
            estadoRetirar: null,
            relaciones: [
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "tipo_documento",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 6,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "Tipos_documento"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                // {
                //     "entidad": {
                //         "nombre": "listados",
                //         "columna_relacion": { "rows": "id" },
                //         "columna_relacion_principal": "medio_administracion",
                //         "order": {
                //             "column": "col",
                //             "type": "asc"
                //         },
                //         "size": 6,
                //         "page": 1,
                //         "where": [
                //             {
                //                 "OR": [
                //                     {
                //                         "nombre_lista": {
                //                             "iLike": "motivos_rechazo_proveedor"
                //                         }
                //                     },
                //                     {
                //                         "nombre_lista": {
                //                             "iLike": "motivos_rechazo_prestador"
                //                         }
                //                     },
                //                     {
                //                         "nombre_lista": {
                //                             "iLike": "motivios_rechazo_institución"
                //                         }
                //                     }
                //                 ]
                //             }
                //         ]
                //     }
                // },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "codigo_departamento" },
                        "columna_relacion_principal": "departamento",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 10000,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "divipola_colombia"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "estado",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "estados"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_proveedor",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_proveedor",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_cliente",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_cliente",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_prestador",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_prestador",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "usuarios",
                        "esquema": "sso",
                        "columna_relacion": "id_usuario",
                        "columna_relacion_principal": "id_usuario",
                        "order": {
                            "column": "id_usuario",
                            "type": "asc"
                        },
                        "size": 1,
                        "page": 1,
                        "where": []
                    }
                }
            ],

        }

    },
    computed: {
        rows() {
            return this.totalfilas
        },
        rowsdos() {
            return this.totalfilasestados
        },
        // Obtener lista única de TODAS las sedes (sin filtrar)
        sedesDisponiblesTodas() {
            if (!this.equiposDisponiblesSinFiltrar || this.equiposDisponiblesSinFiltrar.length === 0) {
                return [];
            }
            const sedes = [...new Set(this.equiposDisponiblesSinFiltrar.map(item => item.sede_de_equipos))];
            return sedes.filter(sede => sede); // Filtrar valores nulos o undefined
        },
        // Equipos filtrados según la sede seleccionada
        equiposDisponiblesFiltrados() {
            if (!this.sedeSeleccionada) {
                return this.equiposDisponibles;
            }
            return this.equiposDisponibles.filter(
                equipo => equipo.sede_de_equipos === this.sedeSeleccionada
            );
        },
        // Elementos disponibles para el retiro: combina domicilio + institución, excluyendo los ya retirados
        elementosDisponiblesRetiro() {
            if (!this.solicitudActualItem) return [];
            // IDs ya retirados en solicitudes anteriores (campo acumulado)
            const yaRetirados = (this.solicitudActualItem.elementos_retirados || []).map(id => String(id));
            const resultado = [];
            const domicilio = this.solicitudActualItem.elementos;
            const institucion = this.solicitudActualItem.elementos_institucion;
            if (Array.isArray(domicilio)) {
                domicilio.forEach(id => {
                    if (!yaRetirados.includes(String(id))) {
                        resultado.push({ id, nombre: this.obtenerNombreElemento(id), tipo: 'Domicilio' });
                    }
                });
            }
            if (Array.isArray(institucion)) {
                institucion.forEach(id => {
                    if (!yaRetirados.includes(String(id))) {
                        resultado.push({ id, nombre: this.obtenerNombreElemento(id), tipo: 'Institución' });
                    }
                });
            }
            return resultado;
        }
    },
    async created() {
        
        var urlweb=window.location.href
        if(urlweb.includes("/mis-solicitudes")){
            this.viewArchivos = true;
        }else if(urlweb.includes("/historial-solicitudes")){
                this.viewArchivos = true;
        }else{
            this.viewArchivos = false;
        }

        this.misSolicitudes();
        try {
            if (this.requiereListas == true) {
                const response = await config.listasDesplegables({
                    "nombre_entidad": "listados",
                })
                this.estadosolicitud = response[10].data.rows.map(x => {
                    return {
                        id: x.id,
                        name: x.name,
                    }
                })
                this.valotipos = response[0].data.rows.map(x => {
                    return {
                        id: x.id,
                        name: x.name,
                    }
                })
                
                // Determinar qué listado de motivos usar según la ruta actual
                let nombreListaMotivos = "motivos_rechazo_proveedor"; // Default para proveedores
                var urlweb = window.location.href;
                
                if (urlweb.includes("/prestador-recepcion-solicitudes")) {
                    nombreListaMotivos = "motivos_rechazo_prestador"; // Listado específico para prestadores
                    console.log("Detectada ruta de prestador - usando motivos_rechazo_prestador");
                } else if(urlweb.includes("/mis-solicitudes") || urlweb.includes("/historial-solicitudes")){
                    nombreListaMotivos = "motivos_rechazo_institución"; // Listado específico para prestadores
                    console.log("Detectada ruta de mis-solicitudes o historial-solicitudes - usando motivos_rechazo_institución");
                
                }else{
                    console.log("Usando motivos_rechazo_proveedor (default)");
                }
                
                const motivoRechazo = response.find(item => item.data.nombre_lista === nombreListaMotivos);
                
                if (motivoRechazo) {
                    this.motivos = motivoRechazo.data.rows.map(x => ({ value: x.id, text: x.name }));
                } else {
                    console.warn(`No se encontró la lista: ${nombreListaMotivos}`);
                    this.motivos = [];
                }

                // Cargar los tres listados de motivos para resolverlos en el historial
                const mapMotivos = r => r ? r.data.rows.map(x => ({ value: x.id, text: x.name })) : [];
                this.motivosProveedor  = mapMotivos(response.find(i => i.data.nombre_lista === 'motivos_rechazo_proveedor'));
                this.motivosPrestador  = mapMotivos(response.find(i => i.data.nombre_lista === 'motivos_rechazo_prestador'));
                this.motivosInstitucion = mapMotivos(response.find(i => i.data.nombre_lista === 'motivos_rechazo_institución'));

                // Cargar listado de elementos para el retiro
                const listaElementos = response.find(i => i.data && i.data.nombre_lista === 'elementos');
                this.valoreselementos = listaElementos ? listaElementos.data.rows : [];

                // Cargar listados para resolución de nombres en exportación
                const listaEps = response.find(i => i.data && i.data.nombre_lista === 'eps_colombia');
                this.valoreseps = listaEps ? listaEps.data.rows : [];
                const listaCobertura = response.find(i => i.data && i.data.nombre_lista === 'tipos_cobertura');
                this.valorescobertura = listaCobertura ? listaCobertura.data.rows : [];
                const listaAfiliacion = response.find(i => i.data && i.data.nombre_lista === 'tipos_afiliacion');
                this.valoresafiliacion = listaAfiliacion ? listaAfiliacion.data.rows : [];
                const listaMediosAdmin = response.find(i => i.data && i.data.nombre_lista === 'medios_administracion');
                this.valoresmediosadmin = listaMediosAdmin ? listaMediosAdmin.data.rows : [];
                const listaCie10 = response.find(i => i.data && i.data.nombre_lista === 'cie10_enfermedades_respiratorias');
                this.valorescie10 = listaCie10 ? listaCie10.data.rows : [];

                this.valoresdepartamentos = response[1].data.rows;
                var departamentos = this.valoresdepartamentos.map(x => {
                    return {
                        'value': x.codigo_departamento,
                        'text': x.nombre_departamento
                    }
                }).filter(
                    (obj, index, self) =>
                        index ===
                        self.findIndex((o) => o.value === obj.value && o.text === obj.text)
                );
                let arraySinDuplicados = [...new Set(departamentos)];

                this.departamentos = arraySinDuplicados
            }
        } catch (error) {
            if (error.response.data.mensaje == 'Token inválido') {
                localStorage.clear();
                return this.$router.push("/error401");

            }
        }



    },
    watch: {
        // Limpiar datos de disponibilidad cuando se cambia entre opciones de asignación
        Aprovedor(newValue) {
            if (newValue !== 'true') {
                this.fechaConsultaDisponibilidad = null;
                this.equiposDisponibles = [];
                this.equiposDisponiblesSinFiltrar = [];
                this.sedeSeleccionada = null;
            }
        }
    },
    methods: {
        // Resolver nombre de un elemento a partir de su ID en la lista de elementos
        obtenerNombreElemento(id) {
            if (!this.valoreselementos || !this.valoreselementos.length) return String(id);
            const found = this.valoreselementos.find(e => e.id === id || e.id === String(id) || String(e.id) === String(id));
            return found ? (found.name || found.nombre || String(id)) : String(id);
        },
        // Resolver el nombre de un ítem a partir de su ID en cualquier lista desplegable
        resolverNombreLista(lista, id) {
            if (!id && id !== 0) return '';
            if (!lista || !lista.length) return String(id);
            const found = lista.find(e => String(e.id) === String(id));
            return found ? (found.name || found.nombre || String(id)) : String(id);
        },
        // Obtener fecha y hora actual en formato datetime-local (YYYY-MM-DDTHH:MM)
        getCurrentDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        },
        // Obtener fecha y hora mínima (para futuro)
        getMinDateTime() {
            return this.getCurrentDateTime();
        },
        // Obtener la fecha y hora de solicitud (createat) en formato datetime-local (YYYY-MM-DDTHH:MM)
        // Se usa como valor mínimo permitido para la fecha de entrega.
        getFechaSolicitudDateTime() {
            if (!this.solicitudActualItem || !this.solicitudActualItem.createat) return null;
            const fecha = new Date(this.solicitudActualItem.createat);
            if (isNaN(fecha.getTime())) return null;
            const year = fecha.getFullYear();
            const month = String(fecha.getMonth() + 1).padStart(2, '0');
            const day = String(fecha.getDate()).padStart(2, '0');
            const hours = String(fecha.getHours()).padStart(2, '0');
            const minutes = String(fecha.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        },
        // Mostrar un aviso de validación garantizando que se vea por encima del b-modal de Bootstrap.
        // (heightAuto:false evita que SweetAlert2 no se renderice dentro de un modal, y el didOpen
        //  fuerza el z-index del contenedor por encima del modal).
        mostrarAvisoFecha(titulo, mensaje) {
            Swal.fire({
                icon: 'warning',
                title: titulo,
                text: mensaje,
                confirmButtonColor: '#f0ad4e',
                heightAuto: false,
                didOpen: () => {
                    const cont = document.querySelector('.swal2-container');
                    if (cont) cont.style.zIndex = '20000';
                }
            });
        },
        // Validar la fecha y hora de entrega antes de gestionar la solicitud.
        // Restricciones:
        //   1. No debe ser mayor a la fecha y hora actual.
        //   2. No debe ser menor a la fecha y hora de solicitud.
        // Retorna true si la fecha es válida; de lo contrario muestra un aviso y retorna false.
        validarFechaEntrega() {
            const fechaEntrega = this.fechaAsignada ? new Date(this.fechaAsignada) : null;
            const ahora = new Date();
            const createat = this.solicitudActualItem ? this.solicitudActualItem.createat : null;
            const fechaSolicitud = createat ? new Date(createat) : null;

            console.log('[validarFechaEntrega] ===== Validando fecha de entrega =====');
            console.log('[validarFechaEntrega] fechaAsignada (input):', this.fechaAsignada);
            console.log('[validarFechaEntrega] fechaEntrega (Date) :', fechaEntrega);
            console.log('[validarFechaEntrega] ahora (Date)        :', ahora);
            console.log('[validarFechaEntrega] createat (solicitud):', createat, '->', fechaSolicitud);

            if (!this.fechaAsignada) {
                console.log('[validarFechaEntrega] Sin fecha asignada, no se valida (botón deshabilitado lo cubre).');
                return true; // el botón deshabilitado ya evita el envío vacío
            }

            if (isNaN(fechaEntrega.getTime())) {
                console.warn('[validarFechaEntrega] Fecha de entrega inválida.');
                this.mostrarAvisoFecha('Fecha inválida', 'La fecha y hora de entrega no es válida.');
                return false;
            }

            // Restricción 1: no puede ser posterior a la fecha y hora actual
            if (fechaEntrega.getTime() > ahora.getTime()) {
                console.warn('[validarFechaEntrega] ❌ Restricción 1: la entrega es POSTERIOR a la fecha/hora actual.');
                this.mostrarAvisoFecha('Fecha no válida', 'La fecha y hora de entrega no puede ser posterior a la fecha y hora actual.');
                return false;
            }

            // Restricción 2: no puede ser anterior a la fecha de solicitud
            if (fechaSolicitud && !isNaN(fechaSolicitud.getTime()) && fechaEntrega.getTime() < fechaSolicitud.getTime()) {
                console.warn('[validarFechaEntrega] ❌ Restricción 2: la entrega es ANTERIOR a la fecha de solicitud.');
                this.mostrarAvisoFecha('Fecha no válida', 'La fecha y hora de entrega no puede ser anterior a la fecha de solicitud (' + this.formatearFechaConOffset(createat, -5) + ').');
                return false;
            }

            console.log('[validarFechaEntrega] ✔ Fecha válida.');
            return true;
        },
        generarIdUnicoSede(equipo) {
            // Generar un ID único para cada sede basado en múltiples campos
            const sede = equipo.sede_de_equipos || 'sin-sede';
            const regional = equipo.regional || 'sin-regional';
            const id = equipo.id || Math.random().toString(36).substr(2, 9);
            return `${sede.replace(/\s+/g, '-')}-${regional.replace(/\s+/g, '-')}-${id}`.toLowerCase();
        },
        aplicarFiltroSede() {
            // Aplicar filtro sin volver a consultar la API
            if (!this.sedeSeleccionada) {
                // Mostrar todas las sedes
                this.equiposDisponibles = this.equiposDisponiblesSinFiltrar;
            } else {
                // Filtrar por sede seleccionada
                this.equiposDisponibles = this.equiposDisponiblesSinFiltrar.filter(
                    equipo => equipo.sede_de_equipos === this.sedeSeleccionada
                );
            }
        },
        async consultarDisponibilidadProveedor() {
            // Solo consultar si hay proveedor y fecha seleccionados
            if (!this.proveedorId || !this.fechaConsultaDisponibilidad) {
                this.equiposDisponibles = [];
                this.equiposDisponiblesSinFiltrar = [];
                return;
            }

            try {
                // Construir el body en el formato correcto que espera la API
                const params = {
                    where: [
                        {
                            "AND": [
                                {
                                    "proveedor": {
                                        "equals": this.proveedorId
                                    }
                                },
                                {
                                    "fecha": {
                                        "equals": this.fechaConsultaDisponibilidad
                                    }
                                }
                            ]
                        }
                    ],
                    relaciones: [
                        {
                            "entidad": {
                                "nombre": "entidad_proveedor",
                                "columna_relacion": "id",
                                "columna_relacion_principal": "proveedor",
                                "order": {
                                    "column": "id",
                                    "type": "asc"
                                },
                                "size": 5,
                                "page": 1,
                                "where": [
                                    {
                                        "AND": [
                                            {
                                                "id": {
                                                    "notEquals": ""
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        }
                    ],
                    size: 100, // Aumentar el tamaño para obtener múltiples registros
                    page: 1,
                    orderBy: "sede_de_equipos", // Ordenar por sede
                    typeOrder: "asc"
                };

                const response = await disponibilidad.consultarDisponibilidadEquipos(params);
                
                console.log('Response completo:', response);
                
                if (response && response.message && response.message.rows && response.message.rows.length > 0) {
                    // Procesar TODOS los registros que vengan de la API
                    const allRows = response.message.rows;
                    console.log(`Se encontraron ${allRows.length} registro(s) de disponibilidad`);
                    
                    const equiposProcesados = allRows.map((rowData) => {
                        const data = rowData.data; // Los datos están dentro de .data
                        
                        // Obtener nombre del proveedor
                        const nombreProveedor = data.entidad_proveedor && data.entidad_proveedor[0] && data.entidad_proveedor[0][0] && data.entidad_proveedor[0][0].d
                            ? data.entidad_proveedor[0][0].d.nombre_proveedor 
                            : `Proveedor ${data.proveedor}`;
                        
                        // Calcular totales
                        const totalDia = parseInt(data.conc_bajo_flujo_dia || 0) + 
                                       parseInt(data.conc_alto_flujo_dia || 0) + 
                                       parseInt(data.conc_portatil_dia || 0) + 
                                       parseInt(data.aspirador_dia || 0) + 
                                       parseInt(data.nebulizador_dia || 0) + 
                                       parseInt(data.oximetro_adul_dia || 0) + 
                                       parseInt(data.oximetro_ped_dia || 0) + 
                                       parseInt(data.bala_portatil_dia || 0) + 
                                       parseInt(data.regulador_ahorrador_dia || 0) + 
                                       parseInt(data.paquete_pediatrico_dia || 0);
                        
                        const totalNoche = parseInt(data.conc_bajo_flujo_noche || 0) + 
                                         parseInt(data.conc_alto_flujo_noche || 0) + 
                                         parseInt(data.conc_portatil_noche || 0) + 
                                         parseInt(data.aspirador_noche || 0) + 
                                         parseInt(data.nebulizador_noche || 0) + 
                                         parseInt(data.oximetro_adul_noche || 0) + 
                                         parseInt(data.oximetro_ped_noche || 0) + 
                                         parseInt(data.bala_portatil_noche || 0) + 
                                         parseInt(data.regulador_ahorrador_noche || 0) + 
                                         parseInt(data.paquete_pediatrico_noche || 0);
                        
                        return {
                            ...data,
                            nombre_proveedor: nombreProveedor,
                            total_dia: totalDia,
                            total_noche: totalNoche
                        };
                    });
                    
                    // Guardar todos los equipos sin filtrar
                    this.equiposDisponiblesSinFiltrar = equiposProcesados;
                    this.equiposDisponibles = equiposProcesados;
                    
                    console.log('equiposDisponibles procesados:', this.equiposDisponibles);
                    
                } else {
                    // No hay disponibilidad para esta fecha
                    console.log('No se encontraron datos de disponibilidad');
                    this.equiposDisponibles = [];
                    this.equiposDisponiblesSinFiltrar = [];
                }
            } catch (error) {
                console.error('Error consultando disponibilidad:', error);
                this.$bvToast.toast('Error al consultar la disponibilidad de equipos', {
                    title: 'Error',
                    variant: 'danger',
                    autoHideDelay: 3000
                });
                this.equiposDisponibles = [];
                this.equiposDisponiblesSinFiltrar = [];
            }
        },
        
        async getBinaryData(id,nombre_entidad_archivo) {
        var data = {

        "nombre_entidad": "archivos",
        "nombre_entidad_archivo":nombre_entidad_archivo,
        "id_entidad": id

        }
     const response = await clientes.ConsultarArchivosentidadId(data);
     this.cantidadImg= response;
     console.log("response",response);
     
     return response; 
    },
    convertBinaryToImage(binaryData,typefile) {
        let mimeType;

    // Verificar el tipo de archivo y asignar el mimeType correspondiente
    if (typefile === '.png' || typefile === '.jpg' || typefile === '.jpeg') {
        mimeType = typefile === '.png' ? 'image/png' : 'image/jpeg';
    } else if (typefile === '.pdf') {
        mimeType = 'application/pdf';  // Tipo MIME para PDF
    } else {
        mimeType = 'application/octet-stream';  // Para otros tipos desconocidos
    }

         // Crear un Blob desde los datos binarios
    const blob = new Blob([new Uint8Array(binaryData)], { type: mimeType });

    // Crear y retornar una URL temporal para el Blob
    const url = URL.createObjectURL(blob);

    return url;
    },
    VisualizarArchivos(item){
        console.log("item",item);
        
    this.$refs['archivoModal'].show()
    this.getBinaryData(this.idSolicitud,this.obtenerNombreArchivo(item.item.estado))

    },
     verArchivos(url) {
        console.log(url);
        
        // Si el archivo está en Azure Storage, abrir directamente la URL temporal
        if (url.is_azure && url.temp_url) {
            window.open(url.temp_url, '_blank');
            return;
        }

        // Si no está en Azure o no hay temp_url, usar el método tradicional con datos binarios
        if (url.data && url.data.data) {
            const imageUrls = this.convertBinaryToImage(url.data.data, url.typefile);
            // Asignar las URLs a la propiedad `imageUrls`
            this.imageUrls = imageUrls;
            window.open(this.imageUrls, '_blank');
        } else {
            console.error('No se puede abrir el archivo: no hay datos disponibles');
        }
    },
        countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert() {
        this.dismissCountDown = this.dismissSecs
      },
        handleFile(event) {
      // Captura los archivos seleccionados
      console.log(event.target.files);
      
      this.files = event.target.files;
    },
        async listaProveedores() {
            try {
                var where = [{
                    "AND": [
                        {
                            "id": {
                                "notEquals": ""
                            }
                        }

                    ]
                }];
                var params = {

                    "nombreEntidad": "entidad_proveedor",
                    "idVersion": 5,
                    "column": "id",
                    "type": "desc",
                    "size": 20,
                    "page": 1,
                }
                const response = await config.getMetaData(params, where, this.relaciones);
                this.proveedores = response.message.rows.map((x) => {
                    var dataa = {
                        'value': x.data.id,
                        'text': x.data.nombre_proveedor,

                    };
                    return dataa;
                });
                // console.log("proveedores",this.proveedores);
            } catch (error) {

            }

        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert(dismissCountDown1) {
            this.dismissCountDown1 = dismissCountDown1

        },
        getToday() {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Establecer la hora a las 00:00:00:00 para evitar problemas de zona horaria.
            return today.toISOString().slice(0, 10);
        },
        descargarFormato() {
            try {
                console.log("datos>>",this.items);
                if (!this.items || this.items.length === 0) {
                    alert('No hay datos para exportar. Por favor, realice una búsqueda primero.');
                    return;
                }

                const dataParaExcel = this.items.map(item => {
                    // Calcular edad a partir de la fecha de nacimiento
                    let edad = '';
                    if (item.nacimiento) {
                        const hoy = new Date();
                        const fechaNac = new Date(item.nacimiento);
                        let age = hoy.getFullYear() - fechaNac.getFullYear();
                        const m = hoy.getMonth() - fechaNac.getMonth();
                        if (m < 0 || (m === 0 && hoy.getDate() < fechaNac.getDate())) age--;
                        edad = age;
                    }
                    console.log("item>>",item);

                    return {
                        'FECHA DE SOLICITUD': item['Fecha solicitud'] || item['F.Solicitud'] || '',
                        'DEPARTAMENTO': item.Departamento || '',
                        'MUNICIPIO': item.Municipio || item.Ciudad || '',
                        'NOMBRE COMPLETO': item.nombre_completo || item.Paciente || '',
                        'TIPO DE IDENTIFICACIÓN': item['Tipo documento'] || item['T.Documento'] || item['T.documento'] || '',
                        'NUMERO DE IDENTIFICACIÓN': item.Documento || item.documento || '',
                        'EDAD': edad,
                        'FECHA DE NACIMIENTO': item.nacimiento || '',
                        'DIRECCIÓN': item.direccion || '',
                        'BARRIO': item.barrio || '',
                        'TELEFONO 1 ( CASA )': item.telefono_1 || '',
                        'TELEFONO 2 (CELULAR U OTRO )': item.telefono_2 || '',
                        'IPS A LA QUE PERTENECE': this.resolverNombreLista(this.valoreseps, item.eps),
                        'PLAN': this.resolverNombreLista(this.valorescobertura, item.cobertura),
                        'TIPO DE AFILIACIÓN (BENEFICIARIO O COTIZANTE)': this.resolverNombreLista(this.valoresafiliacion, item.afiliacion),
                        'NIVEL DE INGRESOS': item.nivel_ingreso || '',
                        'PCTE TEMPORAL O PERMANENTE':  'TEMPORAL',
                        'DIAS DE AUTORIZACION': item.tiempo_revision_medica || '',
                        'TIPO DE EQUIPO OXIGENO (CILINDROS, CONCENTRADOR, TERMO)': Array.isArray(item.elementos)
                            ? item.elementos.map(id => this.obtenerNombreElemento(id)).join(', ')
                            : (item.elementos || ''),
                        'DESCARTABLES': 'SI',
                        'MEDIO DE ADMINISTRACIÓN': Array.isArray(item.medio_administracion)
                            ? item.medio_administracion.map(id => this.resolverNombreLista(this.valoresmediosadmin, id)).join(', ')
                            : (item.medio_administracion ? this.resolverNombreLista(this.valoresmediosadmin, item.medio_administracion) : ''),
                        'CLINICA O IPS, DONDE SE HARA ENTREGA DEL PORTATIL': item.nombre_institucion || '',
                        'OTROS EQUIPOS (Nebulizador, oximetro, camara de hood, aspirador)': (() => {
                            const dom = Array.isArray(item.elementos)
                                ? item.elementos.map(id => this.obtenerNombreElemento(id))
                                : [];
                            const inst = Array.isArray(item.elementos_institucion)
                                ? item.elementos_institucion.map(id => this.obtenerNombreElemento(id))
                                : [];
                            return [...dom, ...inst].join(', ');
                        })(),
                        'DOSIS (En litros o porcentaje)': item.dosis || '',
                        'HORAS DE CONSUMO AL DÍA': item.horas_consumo_dia || '',
                        'CIE 10': (() => {
                            const raw = item.diagnostico || '';
                            if (!raw) return '';
                            const parts = raw.split(' - ');
                            return parts.length >= 2 ? parts[1].trim() : raw;
                        })(),
                        'NOMBRE DEL DIAGNOSTICO': item.diagnostico || '',
                        'OBSERVACIONES': item.observaciones || '',
                        'NOMBRE DE QUIEN SOLICITA EL SERVICIO': item.nombre_prestador || '',
                        'ESTADO': item.Estado || '',
                        'NOMBRE DE MEDICO TRATANTE': item.doctor || item['Médico tratante'] || '',
                        'TIPO DE ID': this.resolverNombreLista(this.valotipos, item.tipo_documento_medico),
                        'ID MEDICO TRATANTE': item.numero_documento_medico || '',
                    };
                });

                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(dataParaExcel);
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Solicitudes');
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(data);
                const link = document.createElement('a');
                link.href = url;
                const fecha = new Date();
                const nombreArchivo = `reporte_formato_${fecha.getFullYear()}${(fecha.getMonth()+1).toString().padStart(2,'0')}${fecha.getDate().toString().padStart(2,'0')}_${fecha.getHours().toString().padStart(2,'0')}${fecha.getMinutes().toString().padStart(2,'0')}.xlsx`;
                link.setAttribute('download', nombreArchivo);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                console.log(`✅ Se exportaron ${dataParaExcel.length} registros con formato personalizado`);
            } catch (error) {
                console.error('❌ Error al descargar Excel con formato:', error);
                alert('Ocurrió un error al generar el archivo Excel. Por favor, intente nuevamente.');
            }
        },
        descargar() {
            try {
                // Verificar que haya datos en la tabla
                if (!this.items || this.items.length === 0) {
                    alert('No hay datos para exportar. Por favor, realice una búsqueda primero.');
                    return;
                }

                // Usar los datos que ya están cargados en this.items
                // Filtrar solo las columnas principales para exportar
                const dataParaExcel = this.items.map(item => {
                    // Crear objeto con las columnas principales para Excel
                    const row = {
                        'N° solicitud': item['N° solicitud'] || item['N°Solicitud'] || item.id || '',
                        'Solicitante': item.Solicitante || item.Cliente || '',
                        'Proveedor': item.Proveedor || '',
                        'F.Valoración': item['F.Valoración'] || '',
                        'F.Retiro oxígeno': item['F.Retiro oxígeno'] || item['F.Retiro elementos'] || '',
                        'F.Entrega elementos': item['F.Entrega elementos'] || '',
                        'Asignó': item['Asignó'] || '',
                        'F.Asignación': item['F.Asignación'] || '',
                        'Fecha solicitud': item['Fecha solicitud'] || item['F.Solicitud'] || '',
                        'Tipo documento': item['Tipo documento'] || item['T.documento'] || item['T.Documento'] || '',
                        'Documento': item.Documento || item['Documento paciente'] || item.documento || '',
                        'Paciente': item.Paciente || item.nombre_completo || '',
                        'Estado': item.Estado || '',
                        'Observación': item['Observación'] || item.observaciones || '',
                        'Departamento': item.Departamento || '',
                        'Municipio': item.Municipio || '',
                        'Dirección': item.direccion || '',
                        'Teléfono 1': item.telefono_1 || '',
                        'Teléfono 2': item.telefono_2 || '',
                        'EPS': item.eps || '',
                        'Diagnóstico': item.diagnostico || '',
                        'Médico tratante': item['Médico tratante'] || item.doctor || '',
                    };
                    
                    return row;
                });

                // Crear un nuevo libro de trabajo de Excel
                const workbook = XLSX.utils.book_new();

                // Crear una hoja y convertir el JSON en una hoja de cálculo
                const worksheet = XLSX.utils.json_to_sheet(dataParaExcel);
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

                // Convertir el libro de trabajo a un Blob
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: 'application/octet-stream' });

                // Crear un enlace para descargar el archivo
                const url = window.URL.createObjectURL(data);
                const link = document.createElement('a');
                link.href = url;

                // Generar nombre de archivo con fecha y hora actual
                const fecha = new Date();
                const nombreArchivo = `reporte_${this.nombreEntidad}_${fecha.getFullYear()}${(fecha.getMonth()+1).toString().padStart(2,'0')}${fecha.getDate().toString().padStart(2,'0')}_${fecha.getHours().toString().padStart(2,'0')}${fecha.getMinutes().toString().padStart(2,'0')}.xlsx`;
                link.setAttribute('download', nombreArchivo);
                document.body.appendChild(link);

                // Simular un clic en el enlace para descargar el archivo
                link.click();

                // Eliminar el enlace del DOM
                document.body.removeChild(link);

                // Log de éxito
                console.log(`✅ Se exportaron ${dataParaExcel.length} registros a Excel`);
            } catch (error) {
                console.error('❌ Error al descargar Excel:', error);
                alert('Ocurrió un error al generar el archivo Excel. Por favor, intente nuevamente.');
            }
        },
        handleChangePage(event) {
            this.currentPage = parseInt(event.target.value);
        },
        async misSolicitudes() {
            if (this.fechafinal < this.fechainicio) {
                this.dismissCountDown = this.dismissSecs
            } else {
                this.esperandoInfo = true;
                try {
                    var where = JSON.parse(JSON.stringify([this.condicionInicial]));
                    if (this.filterByColum && this.filter) {
                        where[0]['AND'].push({
                            [this.filterByColum]: {
                                "iLike": this.filter
                            }
                        })
                    }
                    if (this.fechainicio && this.fechafinal) {
                        where[0]['AND'].push({
                            [this.dateBy]: {
                                "inRange": [this.fechainicio, this.fechafinal]
                            }
                        })
                    }



                    var params = {
                        "nombreEntidad": this.nombreEntidad,
                        "idVersion": this.idVersion,
                        "column": this.column,
                        "type": this.typeOrder,
                        "size": this.perPageInternal,
                        "page": this.currentPage,
                        "typeOrder": this.typeOrder,
                        "filterByColum": this.filterByColum,
                        "filter": this.filter,
                        "dateBy": this.dateBy,
                        "startDate": this.fechainicio,
                        "endDate": this.fechafinal,
                    }
                    const response = await config.getMetaData(params, where, this.relaciones);
                    this.esperandoInfo = false;
                    this.totalfilas = response.message.count
                    this.items = [];

                    if (response.message == 'Error no se encontró datos') {
                        this.totalfilas = 0;
                    }

                    var dataexcel = []
                    var estadosE = response.message.rows;
                    
                    var cantidad = Math.min(this.perPageInternal, estadosE.length);
                    for (var i = 0; i < cantidad; i++) {
                        var numeracion = i;
                        var dataTable = estadosE[i]['data'];


                        const objetoBuscado = dataTable.listados.flat().find(item => item.row_data && item.row_data.id === dataTable.tipo_documento && item.nombre_lista === "Tipos_documento");
                        const nameResultado = objetoBuscado ? objetoBuscado.row_data.name : null;

                        const estadoBuscado = dataTable.listados.flat().find(item => item.row_data && item.row_data.id === dataTable.estado && item.nombre_lista === "estados");
                        const estadoResultado = estadoBuscado ? estadoBuscado.row_data.name : null;

                        const nombreCliente = dataTable.entidad_cliente[0][0]?.d?.nombre_cliente || "";
                        const nombreProveedor = dataTable.entidad_proveedor[0][0]?.d?.nombre_proveedor || "";
                        const nombrePrestador = dataTable.entidad_prestador[0][0]?.d?.nombre_prestador || "";
                        const departamentobuscado = dataTable.listados.flat().find(item => item.row_data && item.row_data.codigo_departamento === dataTable.departamento && item.nombre_lista === "divipola_colombia");
                        const departamentoResultado = departamentobuscado ? departamentobuscado.row_data.nombre_departamento : null;
                        const municipiobuscando =dataTable.listados.flat().find(item => item.row_data && item.row_data.codigo_municipio === dataTable.municipio && item.nombre_lista === "divipola_colombia")
                        const municipioResultado = municipiobuscando ? municipiobuscando.row_data.nombre_municipio : null;
                        const usuarioprestador = dataTable.entidad_prestador[0][0]?.d?.nombre_prestador || "";
                        
                        // Buscar el texto del motivo de devolución del proveedor
                        const motivoDevolucionObj = this.motivosProveedor.find(m => m.value === dataTable.motivo_devolucion_proveedor);
                        const motivoDevolucionTexto = motivoDevolucionObj ? motivoDevolucionObj.text : (dataTable.motivo_devolucion_proveedor || "");
                          

//                         console.log(municipiobuscando);
//                         console.log("dataTable.municipio",dataTable.municipio);
//                         console.log("dataTable.departamento",dataTable.departamento);
// console.log("departamentoResultado",departamentoResultado);
//                         console.log("municipioResultado",municipioResultado);

                        
                        this.tiempoRM = dataTable.tiempo_revision_medica;
                        // console.log("este esssss dataTable---->", this.dataTable)
                       this.items[numeracion] = {
                            'N° solicitud': dataTable.id,
                            'N°Solicitud': dataTable.id,
                            'Solicitante': nombreCliente,
                            'Cliente': nombreCliente,
                            'Proveedor': nombreProveedor,
                            'fecha valoracion': dataTable.fecha_valoracion ? dataTable.fecha_valoracion : '',
                            'F.Valoración': dataTable.fecha_valoracion ? dataTable.fecha_valoracion.slice(0, 10) : '',
                            'F.Retiro oxígeno': dataTable.fecha_retiro_oxigeno ? this.formatearFechaConOffset(dataTable.fecha_retiro_oxigeno, 0) : '',
                            'F.Retiro elementos': dataTable.fecha_retiro_oxigeno ? this.formatearFecha(dataTable.fecha_retiro_oxigeno) : '',
                            'F.Entrega elementos': dataTable.fecha_entrega_elementos ? this.formatearFechaConOffset(dataTable.fecha_entrega_elementos, -5) : '',
                            'Asignó': nombrePrestador,
                            'F.Asignación': dataTable.fecha_asignacion ? this.formatearFechaConOffset(dataTable.fecha_asignacion, -5): '',
                            'Fecha solicitud': dataTable.createat ? this.formatearFechaConOffset(dataTable.createat, -5) : '',
                            'Tipo documento': nameResultado,
                            'T.documento': nameResultado,
                            'T.Documento': nameResultado,
                            'tipo_documento': dataTable.tipo_documento,
                            "Documento": dataTable.documento,
                            "Documento paciente": dataTable.documento,
                            "Paciente": dataTable.nombre_completo,
                            "Estado": estadoResultado,
                            'Observación': dataTable.observaciones,
                            'activo': dataTable.activo,
                            'afiliacion': dataTable.afiliacion,
                            'barrio': dataTable.barrio,
                            'F.Solicitud': dataTable.createat ? this.formatearFechaConOffset(dataTable.createat, -5) : '',
                            'cie_10_diagnostico': dataTable.cie_10_diagnostico,
                            'id': dataTable.id,
                            'cobertura': dataTable.cobertura,
                            'createat': dataTable.createat,
                            'departamento': dataTable.departamento,
                            'Departamento': departamentoResultado,
                            'detalle_entrega': dataTable.detalle_entrega,
                            'diagnostico': dataTable.diagnostico,
                            'direccion': dataTable.direccion,
                            'direccion_entrega': dataTable.direccion_entrega,
                            'documento': dataTable.documento,
                            'genero': dataTable.genero,
                            'nacimiento': dataTable.nacimiento,
                            'nacionalidad': dataTable.nacionalidad,
                            'typevia': dataTable.tipo_via,
                            'numero': dataTable.numero,
                            'number': dataTable.number,
                            'number1': dataTable.number1,
                            'number2': dataTable.number2,
                            'number3': dataTable.number3,
                            'number4': dataTable.number4,
                            'talla': dataTable.talla,
                            'typeinmueble': dataTable.tipo_inmueble,
                            'bloque': dataTable.bloque,
                            'eps': dataTable.eps,
                            'dosis': dataTable.dosis,
                            'namecontacto': dataTable.nombre_contacto,
                            'email': dataTable.email,
                            'obsevacionContact': dataTable.observacion_contacto,
                            'typemascara': dataTable.tipo_mascara,
                            'hora': dataTable.hora_dosis,
                            'doctor': dataTable.doctor,
                            'Médico tratante': dataTable.doctor,
                            'elementos': dataTable.elementos,
                            'elementos_institucion': dataTable.elementos_institucion,
                            'elementos_homologacion': dataTable.elementos_homologacion,
                            'elementos_institucion_homologacion': dataTable.elementos_institucion_homologacion,
                            'estado': dataTable.estado,
                            'horas_consumo_dia': dataTable.horas_consumo_dia,
                            'lugar_entrega': dataTable.lugar_entrega,
                            'medio_administracion': dataTable.medio_administracion,
                            'municipio': dataTable.municipio,
                            'nombre_completo': dataTable.nombre_completo,
                            'nombre_institucion': dataTable.nombre_institucion,
                            'observaciones': dataTable.observaciones,
                            'telefono_1': dataTable.telefono_1,
                            'telefono_2': dataTable.telefono_2,
                            'telefono_3': dataTable.telefono_3,
                            'id_proveedor': dataTable.id_proveedor,
                            'Municipio': municipioResultado,
                            'Ciudad': municipioResultado,
                            'tiempo_revision_medica': dataTable.tiempo_revision_medica,
                            'updateat': dataTable.updateat,
                            'id_paciente': dataTable.id_paciente,
                            'tipo_documento_medico': dataTable.tipo_documento_medico,
                            'numero_documento_medico': dataTable.numero_documento_medico,
                            'email_institucion': dataTable.email_institucion,
                            'id_cliente': dataTable.id_cliente,
                            'tipo_paciente': dataTable.tipo_paciente,
                            'nivel_ingreso': dataTable.nivel_ingreso || null,
                            'ips_paciente': dataTable.ips_paciente || null,
                            // Campos de rechazo del prestador (para corrección de solicitudes devueltas)
                            'motivo_rechazo_prestador': dataTable.motivo_rechazo_prestador,
                            'detalle_rechazo_prestador': dataTable.detalle_rechazo_prestador,
                            'observaciones_rechazo_prestador': dataTable.observaciones_rechazo_prestador,
                            // Campos legacy de rechazo (fallback)
                            'motivo_rechazo': dataTable.motivo_rechazo,
                            'detalle_motivo_rechazo': dataTable.detalle_motivo_rechazo,
                            'observaciones_rechazo': dataTable.observaciones_rechazo,
                            // Campos de devolución del proveedor
                            'motivo_devolucion_proveedor': dataTable.motivo_devolucion_proveedor,
                            'Motivo Devolución': motivoDevolucionTexto,
                            'detalle_devolucion_proveedor': dataTable.detalle_devolucion_proveedor,
                            'observaciones_devolucion_proveedor': dataTable.observaciones_devolucion_proveedor,
                            'Observación Devolución': dataTable.observaciones_devolucion_proveedor,
                            // Elementos seleccionados para retiro
                            'elementos_retiro': dataTable.elementos_retiro,
                            // Elementos ya retirados históricamente (acumulado de IDs)
                            'elementos_retirados': dataTable.elementos_retirados,
                            'nombre_prestador': usuarioprestador
                        };

                    //    console.log("fffffffffffff",this.items)
                         //finalizado
                         const fecha = Date.now();
                            const dia = new Date(fecha);
                            if(this.items.estado != 10){
                                if (this.items['F.Retiro oxígeno'] && this.items['F.Retiro oxígeno'] <= dia.toISOString()) {
                                const response = await clientes.putEstadosSolicitudes({
                                    "nombre_entidad": this.nombreEntidad,
                                    "id_metadata": dataTable.id,
                                    "id_version": this.idVersion,
                                    "estado": 10
                                })
                            }
                            }
                            
                       
                    }

                    // Verificar bloqueos activos para los items cargados si estamos en recepción de solicitudes
                    if (this.opcionAsignar) {
                        try {
                            const idsItems = this.items
                                .filter(item => item && item.id)
                                .map(item => item.id);
                            if (idsItems.length > 0) {
                                const respBloqueos = await clientes.verificarBloqueos(idsItems);
                                const mapBloqueos = {};
                                (respBloqueos.bloqueos || []).forEach(b => {
                                    mapBloqueos[b.id_solicitud] = b;
                                });
                                this.bloqueos = mapBloqueos;
                            }
                        } catch (errBloqueo) {
                            console.warn('[bloqueos] Error al verificar bloqueos:', errBloqueo);
                        }
                    }

                    // Emitir evento para notificar que los datos se cargaron
                    this.$emit('datos-cargados');


                } catch (error) {
                    // console.log("este es le error-------------->",error.response);
                    this.$bvToast.toast(error.response, {
                    title: 'Error',
                    variant: 'danger',
                    autoHideDelay: 3000
                });
                    if (error.response.data.mensaje == 'Token inválido') {
                        localStorage.clear();
                        return this.$router.push("/error401");
                    }


                }
            }
        },
        async retirar(id, estado) {
            if (estado != 1 && estado != 2) {
                return;
            }
            this.$refs['modal-4'].show();
            this.idSolicitud = id;
            this.estadoRetirar = estado;

        },
        async hideModall() {
            if (this.estadoRetirar != 1 && this.estadoRetirar != 2) {
                this.$refs['modal-4'].hide();
                return;
            }
            try {
                const response = await clientes.putEstadosSolicitudes({
                    "nombre_entidad": this.nombreEntidad,
                    "id_metadata": this.idSolicitud,
                    "id_version": this.idVersion,
                    "estado": 11,
                    "motivo_cancelacion_institucion": this.motivo,
                    "detalle_cancelacion_institucion": this.detallemotivo,
                    "observaciones_cancelacion_institucion": this.notaadicional
                })
                this.notaadicional="";
                this.detallemotivo = "";
                this.motivo = null;
                this.guardarImagen(this.idSolicitud,'cancelado');
                this.$refs['modal-4'].hide()
                this.misSolicitudes();
            } catch (error) {
                console.error("Error al cancelar solicitud:", error);
                let mensajeError = 'Ocurrió un error al cancelar la solicitud.';
                if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
                    mensajeError = error.response.data.error.message;
                }
                this.$bvModal.msgBoxOk(mensajeError, {
                    title: 'Error al cancelar solicitud',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Entendido',
                    headerBgVariant: 'danger',
                    headerTextVariant: 'light',
                    centered: true
                });
            }
        },
        async rechazar(id) {
            this.$refs['modal-5'].show();
            this.idSolicitud = id;
        },
        autorizarSolicitud(solicitud) {
            // Emitir evento hacia el componente padre con los datos de la solicitud
            this.$emit('autorizarSolicitud', solicitud);
        },
        async rechazado() {
            try {
                const response = await clientes.putEstadosSolicitudes({
                    "nombre_entidad": this.nombreEntidad,
                    "id_metadata": this.idSolicitud,
                    "id_version": this.idVersion,
                    "estado": 2,
                    "motivo_rechazo_prestador": this.motivo,
                    "detalle_rechazo_prestador": this.detallemotivo,
                    "observaciones_rechazo_prestador": this.notaadicional
                })
                this.detallemotivo = "";
                this.notaadicional = "";
                this.motivo = null;
                this.guardarImagen(this.idSolicitud,'rechazado');
                this.misSolicitudes();
                this.$refs['modal-5'].hide()
            } catch (error) {
                console.error("Error al rechazar solicitud:", error);
                let mensajeError = 'Ocurrió un error al rechazar la solicitud.';
                if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
                    mensajeError = error.response.data.error.message;
                }
                this.$bvModal.msgBoxOk(mensajeError, {
                    title: 'Error al rechazar solicitud',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Entendido',
                    headerBgVariant: 'danger',
                    headerTextVariant: 'light',
                    centered: true
                });
            }
        },
        async devolucion() {
            try {
                const response = await clientes.putEstadosSolicitudes({
                    "nombre_entidad": this.nombreEntidad,
                    "id_metadata": this.idSolicitud,
                    "id_version": this.idVersion,
                    "estado": 4,
                    "id_proveedor": 0,
                    "motivo_devolucion_proveedor": this.motivo,
                    "detalle_devolucion_proveedor": this.detallemotivo,
                    "observaciones_devolucion_proveedor": this.notaadicional
                })
                this.detallemotivo = "";
                this.notaadicional = "";
                this.motivo = null;
                this.guardarImagen(this.idSolicitud,'devuelto');
                this.misSolicitudes();
                this.$refs['modal-5'].hide()
            } catch (error) {
                console.error("Error al devolver solicitud:", error);
                let mensajeError = 'Ocurrió un error al devolver la solicitud.';
                if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
                    mensajeError = error.response.data.error.message;
                }
                this.$bvModal.msgBoxOk(mensajeError, {
                    title: 'Error al devolver solicitud',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Entendido',
                    headerBgVariant: 'danger',
                    headerTextVariant: 'light',
                    centered: true
                });
            }
        },
        clearfiltros() {
            this.$router.go();
        },
        TipoCampo() {
            this.fechainicio = "";
            this.fechafinal = "";
            this.filter = "";
            this.selectedd = null
        },
        paginacion(currentPage) {
            this.currentPage = currentPage;
            this.misSolicitudes();
        },
        paginacionestados(currentPagedos) {
            this.currentPagedos = currentPagedos;
            this.verModal(this.idSolicitud, this.datoactual);
        },
        cambiarItemsPorPaginaEstados() {
            // Resetear a página 1 cuando se cambia el tamaño de página
            this.currentPagedos = 1;
            this.verModal(this.idSolicitud, this.datoactual);
        },
        paginacionestadosv(currentPagedos) {
            this.currentPagedos = currentPagedos;
            this.verhistorialValoracion(this.idSolicitud, this.datoactual);
        },
        seguimientos(id, estado, item) {
            this.idSolicitud = id;
            this.estadoSd = estado;
            this.solicitudActualItem = item || null;
            this.elementosRetiro = [];
            
            // No permitir solicitud de retiro si ya está retirado (estado 13) o en proceso de retiro
            if (estado == 13 || estado == 9 || estado == 14 || estado == 15) {
                this.$bvToast.toast('Esta solicitud ya tiene un proceso de retiro en curso o ya fue retirada.', {
                    title: 'Acción no permitida',
                    variant: 'warning',
                    solid: true,
                    autoHideDelay: 3000
                });
                return;
            }
            
            if (estado == 6) {
                this.$refs['modal-7'].show()
            } else if ((estado == 7 || estado == 16) && this.carpeta !== 'Proveedores') {
                // Solo los prestadores pueden solicitar retiros, nunca los proveedores
                this.$refs['modal-8'].show()
            } else if ((estado == 7 || estado == 16) && this.carpeta === 'Proveedores') {
                this.$bvToast.toast('Los proveedores no pueden solicitar retiros. Use el botón de gestión de retiro.', {
                    title: 'Acción no permitida',
                    variant: 'warning',
                    solid: true,
                    autoHideDelay: 3000
                });
                return;
            }
            else if (estado == 8) {
                 this.$refs['modal-7'].show()
            }
            else {
                this.$refs['modal-2'].show()
            }

        },
        async asignacion(id) {
            // Intentar adquirir bloqueo antes de abrir el modal
            try {
                const resultado = await clientes.bloquearSolicitud(id);
                if (resultado && resultado.bloqueado) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Solicitud en edición',
                        text: resultado.mensaje || 'Esta solicitud está siendo gestionada por otro usuario.',
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#f0ad4e'
                    });
                    this.$set(this.bloqueos, id, { nombre_usuario: resultado.nombre_usuario });
                    return;
                }
            } catch (errBloqueo) {
                // Si el servidor retorna 409 (Conflict) es porque está bloqueada
                if (errBloqueo.response && errBloqueo.response.status === 409) {
                    const data = errBloqueo.response.data;
                    Swal.fire({
                        icon: 'warning',
                        title: 'Solicitud en edición',
                        text: data.mensaje || 'Esta solicitud está siendo gestionada por otro usuario.',
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#f0ad4e'
                    });
                    this.$set(this.bloqueos, id, { nombre_usuario: data.nombre_usuario });
                    return;
                }
                console.warn('[bloqueo] Error al intentar bloquear solicitud:', errBloqueo);
                // Si falla por otro motivo, permitir continuar (degradación elegante)
            }

            this.idSolicitud = id;
            // Limpiar datos de disponibilidad al abrir el modal
            this.fechaConsultaDisponibilidad = null;
            this.equiposDisponibles = [];
            this.equiposDisponiblesSinFiltrar = [];
            this.proveedorId = null;
            this.sedeSeleccionada = null;
            this.$refs['modal-6'].show()
            this.listaProveedores();
        },
        verDocumento(data, item, cliente, editar, proveerdor, carpeta) {

            const datosEnviar = this.datoactual;
            
            // Detectar automáticamente el rol según la ruta actual
            const currentRoute = this.$route.path;
            let prestadorDetectado = 0;
            let proveedorDetectado = 0;
            
            if (currentRoute.includes('/prestador-recepcion-solicitudes') || currentRoute.includes('/prestador-dashboard-solicitudes')) {
                prestadorDetectado = 1;
                console.log('Ruta de prestador detectada');
            } else if (carpeta === 'Proveedores') {
                proveedorDetectado = 1;
                console.log('Carpeta Proveedores detectada, estableciendo proveerdor = 1');
            }
            
            console.log('verDocumento - Ruta actual:', currentRoute);
            console.log('verDocumento - Prestador detectado:', prestadorDetectado);
            console.log('verDocumento - Proveedor detectado:', proveedorDetectado);

            // Si había un bloqueo activo, transferir la responsabilidad de liberarlo a CrearSolicitudes
            const idSolicitudBloqueada = this._bloqueoDetalleActivo ? this.idSolicitud : null;
            this._bloqueoDetalleActivo = false; // evitar que @hide de modal-9 lo libere

            this.$router.push({ 
                name: 'clientes-mis-solicitudes', 
                params: { 
                    myParam: datosEnviar, 
                    cliente: cliente, 
                    editable: editar, 
                    proveerdor: prestadorDetectado || proveedorDetectado, 
                    carpeta: carpeta,
                    prestador: prestadorDetectado,
                    idSolicitudBloqueada: idSolicitudBloqueada
                } 
            });

        },
        async verOpciones(id, datosactuales, data, item, cliente, editar, proveerdor, carpeta) {
            const esPrestador = this.$route.path.includes('/prestador-recepcion-solicitudes');
            if (esPrestador) {
                try {
                    const resultado = await clientes.bloquearSolicitud(id);
                    if (resultado && resultado.bloqueado) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Solicitud en edición',
                            text: resultado.mensaje || 'Esta solicitud está siendo gestionada por otro usuario.',
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#f0ad4e'
                        });
                        this.$set(this.bloqueos, id, { nombre_usuario: resultado.nombre_usuario });
                        return;
                    }
                } catch (errBloqueo) {
                    if (errBloqueo.response && errBloqueo.response.status === 409) {
                        const datos = errBloqueo.response.data;
                        Swal.fire({
                            icon: 'warning',
                            title: 'Solicitud en edición',
                            text: datos.mensaje || 'Esta solicitud está siendo gestionada por otro usuario.',
                            confirmButtonText: 'Entendido',
                            confirmButtonColor: '#f0ad4e'
                        });
                        this.$set(this.bloqueos, id, { nombre_usuario: datos.nombre_usuario });
                        return;
                    }
                    console.warn('[bloqueo] Error al bloquear en verOpciones:', errBloqueo);
                    // Fallo no crítico: continuar sin bloqueo
                }
            }
            this.idSolicitud = id;
            this.datoactual = datosactuales;
            this.indexrow = data;
            this.itemrow = item;
            this.cliente = cliente;
            this.editar = editar;
            this.proveerdor = proveerdor; // Corregir asignación de proveerdor
            this.carpeta = carpeta;
            this.fechaRO = datosactuales['F.Retiro oxígeno'];
            this._bloqueoDetalleActivo = esPrestador;
            this.$refs['modal-9'].show()
        },
        corregirYReenviar(data, item, carpeta) {
            this.$refs['modal-9'].hide();
            const datosEnviar = this.datoactual;
            
            // Resolver el texto del motivo de rechazo (viene como ID, lo convertimos a texto)
            if (datosEnviar.motivo_rechazo_prestador) {
                const motivoEncontrado = (this.motivosPrestador || []).find(i => i.value === datosEnviar.motivo_rechazo_prestador);
                if (motivoEncontrado) {
                    datosEnviar.motivo_rechazo_prestador_texto = motivoEncontrado.text;
                }
            }
            
            this.$router.push({ 
                name: 'clientes-mis-solicitudes', 
                params: { 
                    myParam: datosEnviar, 
                    cliente: 1, 
                    editable: 0,
                    proveerdor: 0, 
                    carpeta: carpeta,
                    prestador: 0,
                    correccion: true
                } 
            });
        },
        async cambioValoracion(id, datosactuales) {
            this.$refs['modal-9'].hide();
            this.$refs['modal-10'].show();
        },
        async verhistorialValoracion(id, datosactuales) {

            try {
                // console.log("datos histprial")
                this.$refs['modal-9'].hide();
                this.idSolicitud = id;
                this.datoactual = datosactuales;
                this.itemsValoracion = [];
                this.$refs['modal-11'].show();
                var where = [{
                    "AND": [
                        {
                            "id": {
                                "equals": id,
                            }
                        },
                        {
                            "fecha_valoracion": {
                                "like": ""
                            }
                        },
                        {
                            "columnasMondificadas": {
                                "iLike": "fecha_valoracion"
                            }
                        },



                    ]
                }];

                if (this.filterByColum1 && this.filter1) {
                    where[0]['AND'].push({
                        [this.filterByColum1]: {
                            "iLike": this.filter1
                        }
                    })
                }
                if (this.fechainicio1 && this.fechafinal1) {
                    where[0]['AND'].push({
                        [this.dateBy]: {
                            "inRange": [this.fechainicio1, this.fechafinal1]
                        }
                    })
                }
                var params = {

                    "nombreEntidad": this.nombreEntidad1,
                    "idVersion": this.idVersion,
                    "column": this.column2,
                    "type": this.typeOrder,
                    "size": this.perPagedos,
                    "page": this.currentPagedos,
                    "typeOrder": this.typeOrder,
                    "filterByColum": this.filterByColum1,
                    "filter": this.filter1,
                    "dateBy": this.dateBy,
                    "startDate": this.fechainicio1,
                    "endDate": this.fechafinal1,
                }
                const response = await config.getMetaData(params, where, this.relaciones);
                console.log("estadoResultado--->ttttt", response)
                this.totalfilasestados = response.message.count;
               
                if (this.totalfilasestados > 0) {

                    this.dataEstados = response.message.rows

                    console.log("estadoResultado--->", this.dataEstados)

                    this.itemsValoracion = this.dataEstados.map((x) => {

                        const estadoBuscado = x.data.listados.flat().find(item => item.row_data && item.row_data.id === x.data.estado && item.nombre_lista === "estados");
                        const estadoResultado = estadoBuscado ? estadoBuscado.row_data.name : null;

                        if (x.data.columnasMondificadas && x.data.columnasMondificadas.includes("fecha_valoracion")) {
                            const fechaValoracionModificada = x.data.fecha_valoracion;
                            console.log(fechaValoracionModificada);
                            if (fechaValoracionModificada != undefined) {
                                var dataa = {
                                    'Fecha': this.formatearFecha(x.data.createat),
                                    'Observación': x.data.observaciones,

                                };
                            }

                            return dataa;
                        }

                    });


                    var increment = 0;
                    var dataPrint = [];

                    for (var i = 0; i < this.totalfilasestados; i++) {
                        if (i >= ((this.currentPagedos - 1) * this.perPagedos)) {
                            dataPrint[i] = this.itemsValoracion[increment]
                            increment++;
                        }
                    }



                    console.log("this.itemsdosvalo--->", this.itemsValoracion)
                    this.itemsValoracion = dataPrint;
                    // if(this.itemsValoracion.length >= 2 ){
                    console.log("datos actualeesss", datosactuales);
                    this.itemsValoracion.push({
                        'Fecha': this.formatearFecha(datosactuales.updateat),
                        'Observación': datosactuales.observaciones,
                    });
                    // }
                    console.log("datos actualeess-----------------------------s", this.itemsValoracion);
                }
            } catch (error) {
                // console.log("este es le error-------------->",error.response);
                if (error.response.data.mensaje == 'Token inválido') {
                    localStorage.clear();
                    return this.$router.push("/error401");
                }


            }

        },
        async verModal(id, datosactuales) {
            if (this.fechafinal1 < this.fechainicio1) {
                this.dismissCountDown1 = this.dismissSecs
            }
            else{
                // console.log("datos histprial")
                this.$refs['modal-9'].hide();
                
                // Solo resetear la paginación si es una nueva solicitud (diferente id)
                if (this.idSolicitud !== id) {
                    console.log("Nueva solicitud - reseteando currentPagedos a 1");
                    this.currentPagedos = 1;
                }
                
                this.idSolicitud = id;
                this.datoactual = datosactuales;
                this.itemsdos = [];
                
                console.log("verModal llamado - currentPagedos:", this.currentPagedos);
                this.$refs['modal-1'].show();
                this.esperandoEstados = true;
                
                try {
                    var where = [{
                        "AND": [
                            {
                                "id": {
                                    "equals": id,
                                }
                            },
                            {
                                "columnasMondificadas": {
                                    "iLike": "estado"
                                }
                            }
                        ]
                    }];

                    if (this.filterByColum1 && this.filter1) {
                        where[0]['AND'].push({
                            [this.filterByColum1]: {
                                "iLike": this.filter1
                            }
                        })
                    }
                    if (this.fechainicio1 && this.fechafinal1) {
                        where[0]['AND'].push({
                            [this.dateBy]: {
                                "inRange": [this.fechainicio1, this.fechafinal1]
                            }
                        })
                    }
                    var params = {
                        "nombreEntidad": this.nombreEntidad1,
                        "idVersion": this.idVersion,
                        "column": this.column2,
                        "type": this.typeOrder,
                        "size": this.perPagedos,
                        "page": this.currentPagedos,
                        "typeOrder": this.typeOrder,
                        "filterByColum": this.filterByColum1,
                        "filter": this.filter1,
                        "dateBy": this.dateBy,
                        "startDate": this.fechainicio1,
                        "endDate": this.fechafinal1,
                    }
                    
                    console.log("Petición estados - Página actual:", this.currentPagedos, "Params:", params);
                    const response = await config.getMetaData(params, where, this.relaciones);
                    this.totalfilasestados = response.message.count;
                    console.log("estadoResultado--->",  response)
                    
                    if (this.totalfilasestados > 0) {
                        this.dataEstados = response.message.rows
                        console.log("estadoResultado--->", this.dataEstados)

                        this.itemsdos = this.dataEstados.map((x,index) => {
                            const estadoBuscado = x.data.listados.flat().find(item => item.row_data && item.row_data.id === x.data.estado && item.nombre_lista === "estados");
                            const estadoResultado = estadoBuscado ? estadoBuscado.row_data.name : null;

                            let actor = '';
                            let tiempoRespuesta = '';

                            switch (x.data.estado) {
                                case 1: // Estado: Nuevo
                                    actor = 'Prestador';
                                    tiempoRespuesta = '0 horas';
                                    break;

                                case 2: // Estado: Rechazado
                                    actor = 'IPS';
                                    tiempoRespuesta = this.calcularDiferenciaHoras(index);
                                    break;

                                case 3: // Estado: En solicitud
                                    actor = 'Proveedor';
                                    tiempoRespuesta = this.calcularDiferenciaHoras(index);
                                    break;

                                case 4: // Estado: En devolución
                                    actor = 'Prestador';
                                    tiempoRespuesta = this.calcularDiferenciaHoras(index);
                                    break;

                                case 5: // Estado: Solicitud tomada
                                    actor = 'Proveedor';
                                    tiempoRespuesta = this.calcularDiferenciaHoras(index);
                                    break;

                                case 9: // Estado: Solicitud de retiro
                                    actor = 'Prestador';
                                    tiempoRespuesta = this.calcularDiferenciaHoras(index);
                                    break;

                                default:
                                    if (x.data.estado > 5) {
                                        actor = 'Proveedor';
                                        tiempoRespuesta = this.calcularDiferenciaHoras(index);
                                    }
                                    break;
                            }

                           

                            const usuarioRaw = x.data.usuarios?.flat()[0]?.d;
                            const usuarioactor = usuarioRaw ? usuarioRaw.nombre_perfil : '';
                            actor =  usuarioactor;
                            console.log("usuarioRaw--->", usuarioRaw)
                            const nombreUsuario = usuarioRaw
                                ? (([usuarioRaw.primer_nombre, usuarioRaw.primer_apellido].filter(Boolean).join(' ').trim() || '') + (usuarioRaw.nombre_usuario ? ' - ' + usuarioRaw.nombre_usuario : '')).trim()
                                : '';

                            console.log("nombreUsuario--->", nombreUsuario) 


                            const dataa = {
                                'Fecha': this.formatearFechaConOffset(x.data.createat,-5),  
                                'Estado': estadoResultado,
                                'estado': x.data.estado,
                                'Actor': actor,
                                'Realizado por': nombreUsuario,
                                'Tiempo respuesta': tiempoRespuesta,
                                'listados': x.data.listados,
                                'Motivo rechazo': (() => {
                                    // Priorizar campos específicos por actor
                                    if (x.data.estado === 11 && x.data.motivo_cancelacion_institucion) {
                                        const m = (this.motivosInstitucion || []).find(i => i.value === x.data.motivo_cancelacion_institucion);
                                        return m ? m.text : x.data.motivo_cancelacion_institucion;
                                    }
                                    if (x.data.estado === 2 && x.data.motivo_rechazo_prestador) {
                                        const m = (this.motivosPrestador || []).find(i => i.value === x.data.motivo_rechazo_prestador);
                                        return m ? m.text : x.data.motivo_rechazo_prestador;
                                    }
                                    if (x.data.estado === 4 && x.data.motivo_devolucion_proveedor) {
                                        const m = (this.motivosProveedor || []).find(i => i.value === x.data.motivo_devolucion_proveedor);
                                        return m ? m.text : x.data.motivo_devolucion_proveedor;
                                    }
                                    // Fallback a campos legacy
                                    if (!x.data.motivo_rechazo) return '';
                                    const lista = x.data.estado === 4
                                        ? this.motivosProveedor
                                        : x.data.estado === 2
                                            ? this.motivosPrestador
                                            : this.motivosInstitucion;
                                    const m = (lista || []).find(i => i.value === x.data.motivo_rechazo);
                                    return m ? m.text : x.data.motivo_rechazo;
                                })(),
                                'Detalle motivo': (() => {
                                    if (x.data.estado === 11 && x.data.detalle_cancelacion_institucion) return x.data.detalle_cancelacion_institucion;
                                    if (x.data.estado === 2 && x.data.detalle_rechazo_prestador) return x.data.detalle_rechazo_prestador;
                                    if (x.data.estado === 4 && x.data.detalle_devolucion_proveedor) return x.data.detalle_devolucion_proveedor;
                                    return x.data.otro_motivo || '';
                                })(),
                                'Observación': (() => {
                                    if (x.data.estado === 11 && x.data.observaciones_cancelacion_institucion) return x.data.observaciones_cancelacion_institucion;
                                    if (x.data.estado === 2 && x.data.observaciones_rechazo_prestador) return x.data.observaciones_rechazo_prestador;
                                    if (x.data.estado === 4 && x.data.observaciones_devolucion_proveedor) return x.data.observaciones_devolucion_proveedor;
                                    return x.data.observaciones || '';
                                })(),
                                'fechaOriginal': x.data.createat,
                                'updateat': x.data.updateat
                            };

                            return dataa;
                        });
                                
                        console.log("this.itemsdos procesados desde API--->", this.itemsdos)
                        
                        // Solo agregar el estado actual en la primera página si no existe en el historial
                        if (this.currentPagedos === 1) {
                            // Verificar si el estado actual ya está en el historial
                            const estadoActualYaExiste = this.itemsdos.some(item => item && item.estado === datosactuales.estado);
                            
                            // Si el estado actual no está en el historial (porque el backend filtró por columnasMondificadas), agregarlo
                            if (!estadoActualYaExiste) {
                                console.log("Estado actual no encontrado en historial, agregándolo:", datosactuales);
                                this.itemsdos.push({
                                    'Fecha': this.formatearFechaConOffset(datosactuales.updateat,-5),
                                    'Estado': datosactuales.Estado,
                                    'estado': datosactuales.estado,
                                    'listados': datosactuales.listados,
                                    'Motivo rechazo': (() => {
                                        // Priorizar campos específicos por actor
                                        if (datosactuales.estado === 11 && datosactuales.motivo_cancelacion_institucion) {
                                            const m = (this.motivosInstitucion || []).find(i => i.value === datosactuales.motivo_cancelacion_institucion);
                                            return m ? m.text : datosactuales.motivo_cancelacion_institucion;
                                        }
                                        if (datosactuales.estado === 2 && datosactuales.motivo_rechazo_prestador) {
                                            const m = (this.motivosPrestador || []).find(i => i.value === datosactuales.motivo_rechazo_prestador);
                                            return m ? m.text : datosactuales.motivo_rechazo_prestador;
                                        }
                                        if (datosactuales.estado === 4 && datosactuales.motivo_devolucion_proveedor) {
                                            const m = (this.motivosProveedor || []).find(i => i.value === datosactuales.motivo_devolucion_proveedor);
                                            return m ? m.text : datosactuales.motivo_devolucion_proveedor;
                                        }
                                        // Fallback a campos legacy
                                        if (!datosactuales.motivo_rechazo) return '';
                                        const lista = datosactuales.estado === 4
                                            ? this.motivosProveedor
                                            : datosactuales.estado === 2
                                                ? this.motivosPrestador
                                                : this.motivosInstitucion;
                                        const m = (lista || []).find(i => i.value === datosactuales.motivo_rechazo);
                                        return m ? m.text : datosactuales.motivo_rechazo;
                                    })(),
                                    'Detalle motivo': (() => {
                                        if (datosactuales.estado === 11 && datosactuales.detalle_cancelacion_institucion) return datosactuales.detalle_cancelacion_institucion;
                                        if (datosactuales.estado === 2 && datosactuales.detalle_rechazo_prestador) return datosactuales.detalle_rechazo_prestador;
                                        if (datosactuales.estado === 4 && datosactuales.detalle_devolucion_proveedor) return datosactuales.detalle_devolucion_proveedor;
                                        return datosactuales.otro_motivo || '';
                                    })(),
                                    'Observación': (() => {
                                        if (datosactuales.estado === 11 && datosactuales.observaciones_cancelacion_institucion) return datosactuales.observaciones_cancelacion_institucion;
                                        if (datosactuales.estado === 2 && datosactuales.observaciones_rechazo_prestador) return datosactuales.observaciones_rechazo_prestador;
                                        if (datosactuales.estado === 4 && datosactuales.observaciones_devolucion_proveedor) return datosactuales.observaciones_devolucion_proveedor;
                                        return datosactuales.observaciones || '';
                                    })(),
                                    'Actor': this.getActor(datosactuales.estado),
                                    'Realizado por': '',
                                    'Tiempo respuesta': this.calcularDiferenciaTiempo(datosactuales, this.itemsdos[this.itemsdos.length - 1]),
                                    'fechaOriginal': datosactuales.updateat,
                                    'updateat': datosactuales.updateat
                                });
                            }
                        }
                    }
                } catch (error) {
                    console.error("Error al obtener historial de estados:", error);
                    this.itemsdos = [];
                    this.totalfilasestados = 0;
                } finally {
                    this.esperandoEstados = false;
                }
            }
        },
        async verHistorialModificaciones(id, datosactuales) {
            try {
                this.idSolicitud = id;
                this.datoactual = datosactuales;
                this.itemsModificaciones = [];
                this.$refs['modal-modificaciones'].show();
                
                // Construir el where para obtener TODAS las modificaciones
                var where = [{
                    "AND": [
                        {
                            "id": {
                                "equals": id,
                            }
                        }
                    ]
                }];

                // Agregar filtros si están presentes
                if (this.filterModificaciones) {
                    where[0]['AND'].push({
                        "observaciones": {
                            "iLike": this.filterModificaciones
                        }
                    })
                }
                
                if (this.fechainicioModificaciones && this.fechafinalModificaciones) {
                    where[0]['AND'].push({
                        [this.dateBy]: {
                            "inRange": [this.fechainicioModificaciones, this.fechafinalModificaciones]
                        }
                    })
                }

                var params = {
                    "nombreEntidad": this.nombreEntidad1,
                    "idVersion": this.idVersion,
                    "column": this.column2,
                    "type": this.typeOrder,
                    "size": this.perPageModificaciones,
                    "page": this.currentPageModificaciones,
                    "typeOrder": this.typeOrder,
                    "filterByColum": null,
                    "filter": this.filterModificaciones,
                    "dateBy": this.dateBy,
                    "startDate": this.fechainicioModificaciones,
                    "endDate": this.fechafinalModificaciones,
                }

                const response = await config.getMetaData(params, where, this.relaciones);
                console.log("Historial Modificaciones --->", response);
                
                this.totalfilasModificaciones = response.message.count;
                
                if (this.totalfilasModificaciones > 0) {
                    const dataModificaciones = response.message.rows;
                    
                    this.itemsModificaciones = dataModificaciones.map((x) => {
                        console.log("x.data--->", x.data);
                        // Obtener el usuario que modificó
                        const usuarioRaw = x.data.usuarios?.flat()[0]?.d;
                        let usuario = usuarioRaw
                            ? (([usuarioRaw.primer_nombre, usuarioRaw.primer_apellido].filter(Boolean).join(' ').trim() || '') + (usuarioRaw.nombre_usuario ? ' - ' + usuarioRaw.nombre_usuario : '')).trim() || 'Sistema'
                            : 'Sistema';

                        // Obtener las columnas modificadas y sus valores
                        let columnasModificadas = 'No especificado';
                        if (x.data.columnasMondificadas) {
                            let columnas = [];
                            let columnasArray = [];
                            
                            // Convertir a array si es necesario
                            if (Array.isArray(x.data.columnasMondificadas)) {
                                columnasArray = x.data.columnasMondificadas;
                            } else if (typeof x.data.columnasMondificadas === 'string') {
                                columnasArray = x.data.columnasMondificadas.split(',').map(c => c.trim());
                            }
                            
                            // Mapa de nombres legibles para las columnas
                            const nombresLegibles = {
                                'motivo_rechazo': 'Motivo rechazo (legacy)',
                                'otro_motivo': 'Detalle motivo (legacy)',
                                'motivo_cancelacion_institucion': 'Motivo cancelación (Institución)',
                                'detalle_cancelacion_institucion': 'Detalle cancelación (Institución)',
                                'observaciones_cancelacion_institucion': 'Obs. cancelación (Institución)',
                                'motivo_rechazo_prestador': 'Motivo rechazo (Prestador)',
                                'detalle_rechazo_prestador': 'Detalle rechazo (Prestador)',
                                'observaciones_rechazo_prestador': 'Obs. rechazo (Prestador)',
                                'motivo_devolucion_proveedor': 'Motivo devolución (Proveedor)',
                                'detalle_devolucion_proveedor': 'Detalle devolución (Proveedor)',
                                'observaciones_devolucion_proveedor': 'Obs. devolución (Proveedor)',
                                'estado': 'Estado',
                                'observaciones': 'Observaciones',
                                'id_proveedor': 'Proveedor',
                                'id_prestador': 'Prestador',
                                'fecha_valoracion': 'Fecha valoración',
                                'fecha_retiro_oxigeno': 'Fecha retiro oxígeno',
                                'fecha_entrega_elementos': 'Fecha entrega elementos',
                                'fecha_asignacion': 'Fecha asignación',
                                'fecha_asignada': 'Fecha asignada',
                            };

                            // Para cada columna modificada, obtener su valor
                            columnasArray.forEach(columna => {
                                let valor = x.data[columna];
                                let nombreColumna = nombresLegibles[columna] || columna;
                                
                                // Manejar casos especiales
                                if (columna === 'estado' && x.data.listados) {
                                    // Buscar el nombre del estado en los listados
                                    const estadoBuscado = x.data.listados.flat().find(
                                        item => item.row_data && item.row_data.id === valor && item.nombre_lista === "estados"
                                    );
                                    if (estadoBuscado && estadoBuscado.row_data) {
                                        valor = estadoBuscado.row_data.name;
                                    }
                                }

                                // Resolver motivos contra sus listas respectivas
                                if ((columna === 'motivo_rechazo' || columna === 'motivo_rechazo_prestador') && valor) {
                                    const m = (this.motivosPrestador || []).find(i => i.value === valor);
                                    if (m) valor = m.text;
                                }
                                if (columna === 'motivo_devolucion_proveedor' && valor) {
                                    const m = (this.motivosProveedor || []).find(i => i.value === valor);
                                    if (m) valor = m.text;
                                }
                                if (columna === 'motivo_cancelacion_institucion' && valor) {
                                    const m = (this.motivosInstitucion || []).find(i => i.value === valor);
                                    if (m) valor = m.text;
                                }
                                
                                // Formatear fechas si es necesario
                                if (columna.includes('fecha') && valor) {
                                    if (typeof valor === 'string' && valor.length > 10) {
                                        valor = this.formatearFecha(valor);
                                    }
                                }
                                
                                // Si el valor es null o undefined, mostrar "Sin valor"
                                if (valor === null || valor === undefined || valor === '') {
                                    valor = 'Sin valor';
                                }
                                
                                // Agregar al array de columnas con formato legible
                                columnas.push(`${nombreColumna}: ${valor}`);
                            });
                            
                            columnasModificadas = columnas.length > 0 ? columnas.join(' | ') : 'No especificado';
                        }

                        return {
                            'Fecha': this.formatearFechaConOffset(x.data.createat,-5),
                            'Columnas Modificadas': columnasModificadas,
                            'Usuario': usuario,
                            'Observación': x.data.observaciones || 'Sin observaciones',
                        };
                    });

                    // Paginación
                    var increment = 0;
                    var dataPrint = [];
                    for (var i = 0; i < this.totalfilasModificaciones; i++) {
                        if (i >= ((this.currentPageModificaciones - 1) * this.perPageModificaciones)) {
                            dataPrint[i] = this.itemsModificaciones[increment];
                            increment++;
                        }
                    }
                    this.itemsModificaciones = dataPrint;

                    console.log("Items modificaciones procesados--->", this.itemsModificaciones);
                }
            } catch (error) {
                console.error("Error al cargar historial de modificaciones:", error);
            }
        },
        async paginacionModificaciones(pagina) {
            this.currentPageModificaciones = pagina;
            await this.verHistorialModificaciones(this.idSolicitud, this.datoactual);
        },
        obtenerNombreArchivo(estado) {
            let nombreEntidadArchivo = '';

            switch (estado) {
                case 1: // Estado: Nuevo
                nombreEntidadArchivo = 'creacion_solicitud';
                break;
                case 2: // Estado: Rechazado
                nombreEntidadArchivo = 'rechazado';
                break;
                case 3: // Estado: En solicitud
                nombreEntidadArchivo = 'solicitud';
                break;
                case 4: // Estado: En devolución
                nombreEntidadArchivo = 'devuelto';
                break;
                case 5: // Estado: Solicitud tomada
                nombreEntidadArchivo = 'solicitud_tomada';
                break;
                case 6: 
                nombreEntidadArchivo = 'proceso_entrega';
                break;
                 case 7: 
                nombreEntidadArchivo = 'entregado';
                break;
                 case 8: 
                nombreEntidadArchivo = 'fallo_entrega';
                break;
                 case 9: 
                nombreEntidadArchivo = 'solicitud_retiro';
                break;
                 case 10: 
                nombreEntidadArchivo = 'finalizado';
                break;
                case 11: 
                nombreEntidadArchivo = 'cancelado';
                break;
                case 12:
                nombreEntidadArchivo = 'segundo_intento_entrega';
                break;
                case 13:
                nombreEntidadArchivo = 'retiro_efectivo';
                break;
                case 14: // NUEVO: En proceso de retiro
                nombreEntidadArchivo = 'en_proceso_retiro';
                break;
                case 15: // NUEVO: Retiro fallido
                nombreEntidadArchivo = 'retiro_fallido';
                break;
                default:
                nombreEntidadArchivo = 'otros_archivos';
                break;
            }

            return nombreEntidadArchivo;
            },
        calcularDiferenciaTiempo(actual, anterior) {
            if (!anterior) return '0 horas'; // Si no hay registro anterior
            const fechaActual = new Date(actual.updateat);
            // Si anterior.Fecha ya fue formateada, usar anterior.fechaOriginal o reconstruir
            const fechaAnterior = anterior.fechaOriginal ? new Date(anterior.fechaOriginal) : new Date(anterior.updateat || anterior.Fecha);

            if (isNaN(fechaActual) || isNaN(fechaAnterior)) {
                console.error('Fecha no válida encontrada:', fechaActual, fechaAnterior);
                return 'Fecha no válida';
            }

            const diferenciaMs = fechaActual - fechaAnterior;
            const diferenciaMinutos = Math.floor(Math.abs(diferenciaMs) / (1000 * 60));
            const diferenciaHoras = Math.floor(Math.abs(diferenciaMs) / (1000 * 60 * 60));
            const diferenciaDias = Math.floor(Math.abs(diferenciaMs) / (1000 * 60 * 60 * 24));

            if (diferenciaDias > 0) {
                return `${diferenciaDias} día(s)`;
            } else if (diferenciaHoras > 0) {
                return `${diferenciaHoras} hora(s)`;
            } else {
                return `${diferenciaMinutos} minuto(s)`;
            }
        },
        getActor(estado) {
            switch (estado) {
                case 1: return 'Prestador';
                case 2: return 'Cliente';
                case 3: return 'Proveedor';
                case 4: return 'Prestador';
                case 5: return 'Proveedor';
                case 9: return 'Prestador';
                default:
                    return estado > 5 ? 'Proveedor' : 'Desconocido';
            }
        },
         calcularDiferenciaHoras(index) {
            try {
                if (index === 0) return '0 horas'; // Si es el primer registro, no hay tiempo previo

                // Verificar que dataEstados existe y tiene los elementos necesarios
                if (!this.dataEstados || !this.dataEstados[index] || !this.dataEstados[index - 1]) {
                    console.warn('dataEstados no disponible o índice fuera de rango:', index);
                    return '0 horas';
                }

                // Obtener las fechas, usar createat como respaldo
                const fechaActualStr = this.dataEstados[index].data.updateat || this.dataEstados[index].data.createat;
                const fechaAnteriorStr = this.dataEstados[index - 1].data.updateat || this.dataEstados[index - 1].data.createat;

                if (!fechaActualStr || !fechaAnteriorStr) {
                    console.warn('Fechas no disponibles en registros:', index);
                    return '0 horas';
                }

                const fechaActual = new Date(fechaActualStr);
                const fechaAnterior = new Date(fechaAnteriorStr);

                // Validar que las fechas sean válidas
                if (isNaN(fechaActual.getTime()) || isNaN(fechaAnterior.getTime())) {
                    console.error('Fecha no válida encontrada:', fechaActualStr, fechaAnteriorStr);
                    return 'Fecha no válida';
                }

                const diferenciaMs = Math.abs(fechaActual - fechaAnterior);
                const diferenciaMinutos = Math.floor(diferenciaMs / (1000 * 60));
                const diferenciaHoras = Math.floor(diferenciaMs / (1000 * 60 * 60));
                const diferenciaDias = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));

                if (diferenciaDias > 0) {
                    return `${diferenciaDias} día(s)`;
                } else if (diferenciaHoras > 0) {
                    return `${diferenciaHoras} hora(s)`;
                } else {
                    return `${diferenciaMinutos} minuto(s)`;
                }
            } catch (error) {
                console.error('Error en calcularDiferenciaHoras:', error, 'índice:', index);
                return '0 horas';
            }
        },
        async gestion(id) {
            const datosUser = localStorage.getItem('user');
            let datoUserJSON = JSON.parse(datosUser);
            let dato_proveedor = datoUserJSON.id_proveedor;
            if (this.intento == true) {
                const response = await clientes.putEstadosSolicitudes({
                    "nombre_entidad": this.nombreEntidad,
                    "id_metadata": id,
                    "id_version": this.idVersion,
                    "estado": 6,
                    "observaciones":this.notaadicional

                })
                this.notaadicional="";
                this.$refs['modal-2'].hide(),
                this.guardarImagen(id,'proceso_entrega');
                    this.misSolicitudes();
            } else {
                if (this.botonmodal == 'Gestionar') {
                    const response = await clientes.putEstadosSolicitudes({
                        "nombre_entidad": this.nombreEntidad,
                        "id_metadata": id,
                        "id_version": this.idVersion,
                        "estado": 5,
                        //"id_proveedor": 0,
                    "id_proveedor": dato_proveedor,
                        "observaciones":this.notaadicional

                    })
                    this.notaadicional="";
                    this.guardarImagen(id,'solicitud_tomada');
                    this.$refs['modal-2'].hide()
                    this.$refs['modal-3'].show()
                } else {
                    this.notaadicional = "";
                    this.$refs['modal-2'].hide()
                      this.guardarImagen(id,'toma_solicitud');
                    this.misSolicitudes();
                }
            }



        },
        async CambioFechaValoracion(id) {

            const fechacambiovaloracion = new Date(this.fechavaloracionasas)
            const fechacamval = fechacambiovaloracion.toISOString().split('T')[0] + 'T00:00:00.000Z';
            const response = await clientes.putEstadosSolicitudes({
                "nombre_entidad": this.nombreEntidad,
                "id_metadata": id,
                "id_version": this.idVersion,
                "fecha_valoracion": fechacamval,
                "observaciones":this.notaadicional
            })
            this.notaadicional="";
            this.misSolicitudes();
            this.$refs['modal-10'].hide()
        },
        async CambioEstado(id) {

            try{
            // Validar restricciones de la fecha/hora de entrega (no aplica al flujo de retiro,
            // que usa fecharetiro con reglas distintas).
            const esFlujoRetiro = (this.estadoSd == 7 || this.estadoSd == 16);
            console.log('[CambioEstado] Iniciado. estadoSd:', this.estadoSd, '| esFlujoRetiro:', esFlujoRetiro, '| estadoActivo:', this.estadoActivo);
            if (!esFlujoRetiro && !this.validarFechaEntrega()) {
                console.log('[CambioEstado] Cancelado: la fecha de entrega no cumple las restricciones.');
                return;
            }

            const fecha = Date.now();
            const dia = new Date(fecha);
            
            // Convertir datetime-local a ISO string para retiro
            let fecharetirosolitud = null;
            if (this.fecharetiro) {
                const fechaRetiroObj = new Date(this.fecharetiro);
                fecharetirosolitud = fechaRetiroObj.toISOString();
            }
            
            // Convertir datetime-local a ISO string para asignación/entrega
            let fechaAsignadaISO = null;
            let fechaemtregaelemenetos = null;
            if (this.fechaAsignada) {
                const fechaAsignadaObj = new Date(this.fechaAsignada);
                fechaAsignadaISO = fechaAsignadaObj.toISOString();
                fechaemtregaelemenetos = fechaAsignadaObj;
            } else {
                fechaemtregaelemenetos = new Date((dia.toISOString()));
            }

            var fechavaloracion = new Date((dia.toISOString()));
            fechavaloracion.setDate(fechavaloracion.getDate() + this.tiempoRM);
            var fechaFormateada = fechavaloracion.toISOString().split('T')[0] + 'T00:00:00.000Z';
            console.log("fffff >>>>>>>> estadoi >>>>>>>>>", this.estadoActivo);
            console.log("fffff >>>>>>>> this.estadoSd  >>>>>>>>>", this.estadoSd);
            const datosUser = localStorage.getItem('user');
            let datoUserJSON = JSON.parse(datosUser);
            let dato_proveedor = datoUserJSON.id_proveedor;

            if (this.estadoActivo == 'true') {
                if (this.estadoSd == 7 || this.estadoSd == 16) {
                    const response = await clientes.putEstadosSolicitudes({
                        "nombre_entidad": this.nombreEntidad,
                        "id_metadata": id,
                        "id_version": this.idVersion,
                        "fecha_retiro_oxigeno": fecharetirosolitud,
                        "estado": 9,
                        "observaciones": this.notaadicional,
                        "elementos_retiro": this.elementosRetiro.length > 0 ? this.elementosRetiro : null,
                        // Preservar el historial de elementos ya retirados en ciclos anteriores
                        "elementos_retirados": this.solicitudActualItem ? this.solicitudActualItem.elementos_retirados : null
                    })
                    this.$refs['modal-8'].hide()
                    this.notaadicional = "";
                    this.fecharetiro = null;
                    this.elementosRetiro = [];
                    this.guardarImagen(id, 'solicitud_retiro');

                }
                else {
                    const response = await clientes.putEstadosSolicitudes({
                        "nombre_entidad": this.nombreEntidad,
                        "id_metadata": id,
                        "id_version": this.idVersion,
                        "estado": 7,
                        "fecha_valoracion": fechaFormateada,
                        "fecha_asignada": fechaAsignadaISO ? new Date(fechaAsignadaISO) : new Date(this.fechaAsignada),
                        "fecha_entrega_elementos": fechaemtregaelemenetos,
                        "observaciones": this.notaadicional
                    })
                    this.notaadicional = "";
                    this.fechaAsignada = null;
                    this.guardarImagen(id, 'entregado');
                }

            }
            else if (this.estadoSd == 8) {
                const response = await clientes.putEstadosSolicitudes({
                    "nombre_entidad": this.nombreEntidad,
                    "id_metadata": id,
                    "id_version": this.idVersion,
                    "estado": 4,
                    "fecha_asignada": fechaAsignadaISO ? new Date(fechaAsignadaISO) : new Date(this.fechaAsignada),
                    //"id_proveedor": 0,
                    "id_proveedor": dato_proveedor,
                    "observaciones": this.notaadicional
                })
                 this.notaadicional = "";
                this.fechaAsignada = null;
                this.fechaAsignada = "";
                this.guardarImagen(id, 'fallo_entrega');
            } else if (this.estadoSd == 12) {
                const response = await clientes.putEstadosSolicitudes({
                    "nombre_entidad": this.nombreEntidad,
                    "id_metadata": id,
                    "id_version": this.idVersion,
                    "estado": 4,
                    "fecha_asignada": fechaAsignadaISO ? new Date(fechaAsignadaISO) : new Date(this.fechaAsignada),
                    //"id_proveedor": 0,
                    "id_proveedor": dato_proveedor,
                    "observaciones": this.notaadicional
                })
                 this.notaadicional = "";
                this.fechaAsignada = null;
                this.guardarImagen(id, 'devuelto');
            }
            else {
                const response = await clientes.putEstadosSolicitudes({
                    "nombre_entidad": this.nombreEntidad,
                    "id_metadata": id,
                    "id_version": this.idVersion,
                    "estado": 8,
                    //"id_proveedor": 0,
                    "id_proveedor": dato_proveedor,
                    "fecha_asignada": fechaAsignadaISO ? new Date(fechaAsignadaISO) : new Date(this.fechaAsignada),
                    "observaciones": this.notaadicional
                })
                this.notaadicional = "";
                this.fechaAsignada = null;
                this.guardarImagen(id, 'fallo_entrega');
            }

            this.misSolicitudes();
            this.$refs['modal-7'].hide()

            }
            catch(error){
                 console.error("Error al cambiar estado:", error.response.data.error.message);

                alert(error.response.data.error.message);
                this.$bvToast.toast(error.response.data.error.message, {
                    title: 'Error cambiando el estado',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 30000
                });
            }

        },
        
        // Método para abrir el modal de gestión de retiro del proveedor (mejorado)
        gestionarRetiroProveedor(id, estadoActual, item) {
            this.idSolicitud = id;
            this.estadoActualRetiro = estadoActual;
            this.itemRetiroGestion = item || null;
            this.fechaRetiroGestion = null;
            this.opcionRetiroSeleccionada = null;
            this.notaadicional = "";
            this.files = null;
            
            // Validar que el estado actual permita gestión de retiro
            if (estadoActual !== 9 && estadoActual !== 14 && estadoActual !== 15 && estadoActual !== 16) {
                this.$bvToast.toast('Esta solicitud no se encuentra en un estado válido para gestionar el retiro.', {
                    title: 'Estado no válido',
                    variant: 'warning',
                    solid: true,
                    autoHideDelay: 3000
                });
                return;
            }
            
            this.$refs['modal-retiro-proveedor'].show();
        },

        // Método para cerrar el modal y limpiar los campos
        cerrarModalRetiroProveedor() {
            this.fechaRetiroGestion = null;
            this.opcionRetiroSeleccionada = null;
            this.notaadicional = "";
            this.files = null;
            this.$refs['modal-retiro-proveedor'].hide();
        },

        // Método para obtener el variant del botón según la opción seleccionada
        getVariantBotonRetiro() {
            switch(this.opcionRetiroSeleccionada) {
                case 'proceso':
                    return 'primary';
                case 'fallido':
                    return 'danger';
                case 'retirado':
                    return 'success';
                default:
                    return 'secondary';
            }
        },

        // Método para procesar el retiro según la opción seleccionada
        async procesarRetiroProveedor(id) {
            try {
                // Validar que se haya seleccionado una opción y fecha
                if (!this.opcionRetiroSeleccionada || !this.fechaRetiroGestion) {
                    this.$bvToast.toast('Por favor seleccione una opción y la fecha/hora.', {
                        title: 'Campos requeridos',
                        variant: 'warning',
                        solid: true,
                        autoHideDelay: 3000
                    });
                    return;
                }

                // Convertir datetime-local a ISO string
                const fechaRetiroObj = new Date(this.fechaRetiroGestion);
                const fechaRetiroFormateada = fechaRetiroObj.toISOString();

                let estadoNuevo = null;
                let nombreEstado = '';
                let tipoArchivo = '';
                let campoFecha = '';

                // Determinar el estado según la opción seleccionada
                switch(this.opcionRetiroSeleccionada) {
                    case 'proceso':
                        estadoNuevo = 14; // En proceso de retiro
                        nombreEstado = 'En proceso de retiro';
                        tipoArchivo = 'en_proceso_retiro';
                        campoFecha = 'fecha_proceso_retiro';
                        // Validar que solo se puede ir a "En proceso" desde estado 9 o 15
                        // Validar que solo se puede ir a "En proceso" desde estado 9, 15 o 16
                        if (this.estadoActualRetiro !== 9 && this.estadoActualRetiro !== 15 && this.estadoActualRetiro !== 16) {
                            this.$bvToast.toast('Solo puede marcar como "En proceso de retiro" desde los estados "Solicitud de retiro", "Retiro parcial" o "Retiro fallido".', {
                                title: 'Transición no válida',
                                variant: 'danger',
                                solid: true,
                                autoHideDelay: 5000
                            });
                            return;
                        }
                        break;
                    case 'fallido':
                        estadoNuevo = 15; // Retiro fallido
                        nombreEstado = 'Retiro fallido';
                        tipoArchivo = 'retiro_fallido';
                        campoFecha = 'fecha_retiro_fallido';
                        // Validar que solo se puede marcar como fallido desde estado 14
                        if (this.estadoActualRetiro !== 14) {
                            this.$bvToast.toast('Solo puede marcar como "Retiro fallido" cuando el estado actual es "En proceso de retiro".', {
                                title: 'Transición no válida',
                                variant: 'danger',
                                solid: true,
                                autoHideDelay: 5000
                            });
                            return;
                        }
                        break;
                    case 'retirado':
                        tipoArchivo = 'retiro_efectivo';
                        campoFecha = 'fecha_retiro_efectivo';
                        // Validar que solo se puede marcar como retirado desde estado 14
                        if (this.estadoActualRetiro !== 14) {
                            this.$bvToast.toast('Solo puede marcar como "Retirado" cuando el estado actual es "En proceso de retiro".', {
                                title: 'Transición no válida',
                                variant: 'danger',
                                solid: true,
                                autoHideDelay: 5000
                            });
                            return;
                        }
                        // Detectar si es retiro parcial o completo comparando los elementos retirados con el total
                        {
                            const totalDomicilio = Array.isArray(this.itemRetiroGestion && this.itemRetiroGestion.elementos) ? this.itemRetiroGestion.elementos.length : 0;
                            const totalInstitucion = Array.isArray(this.itemRetiroGestion && this.itemRetiroGestion.elementos_institucion) ? this.itemRetiroGestion.elementos_institucion.length : 0;
                            const totalElementos = totalDomicilio + totalInstitucion;
                            const retiradosAnteriores = (this.itemRetiroGestion && this.itemRetiroGestion.elementos_retirados) || [];
                            const retiradosAhora = ((this.itemRetiroGestion && this.itemRetiroGestion.elementos_retiro) || []).map(e => e.id);
                            const acumulados = [...new Set([...retiradosAnteriores.map(id => String(id)), ...retiradosAhora.map(id => String(id))])];
                            const esRetiroParcial = totalElementos > 0 && acumulados.length < totalElementos;
                            estadoNuevo = esRetiroParcial ? 16 : 13;
                            nombreEstado = esRetiroParcial ? 'Retiro parcial' : 'Retirado';
                            // Guardar acumulado para persistir en la API
                            this._elementosRetiradosAcumulados = acumulados;
                        }
                        break;
                    default:
                        return;
                }

                // Activar loading DESPUÉS de todas las validaciones
                this.loadingRetiroProveedor = true;

                // Preparar el objeto de actualización con el campo de fecha correcto
                const datosActualizacion = {
                    "nombre_entidad": this.nombreEntidad,
                    "id_metadata": id,
                    "id_version": this.idVersion,
                    "estado": estadoNuevo,
                    "observaciones": this.notaadicional
                };
                
                // Agregar el campo de fecha correspondiente
                datosActualizacion[campoFecha] = fechaRetiroFormateada;

                // Si es 'retirado' (parcial o completo), persistir los elementos retirados acumulados
                if (this.opcionRetiroSeleccionada === 'retirado' && this._elementosRetiradosAcumulados) {
                    datosActualizacion.elementos_retirados = this._elementosRetiradosAcumulados;
                }

                // Realizar la actualización del estado
                const response = await clientes.putEstadosSolicitudes(datosActualizacion);

                console.log(`Respuesta de cambio de estado a ${nombreEstado}:`, response);

                // Guardar las imágenes adjuntas si existen
                if (this.files && this.files.length > 0) {
                    await this.guardarImagen(id, tipoArchivo);
                }

                // Limpiar los campos
                this.notaadicional = "";
                this.fechaRetiroGestion = null;
                this.opcionRetiroSeleccionada = null;
                this.files = null;

                // Cerrar el modal
                this.$refs['modal-retiro-proveedor'].hide();

                // Mostrar mensaje de éxito
                const mensajeExito = estadoNuevo === 16
                    ? `Retiro parcial registrado. El prestador podrá solicitar el retiro de los elementos pendientes.`
                    : `El estado de la solicitud ha sido actualizado a "${nombreEstado}" exitosamente.`;
                this.$bvToast.toast(mensajeExito, {
                    title: estadoNuevo === 16 ? 'Retiro parcial registrado' : 'Actualización Exitosa',
                    variant: estadoNuevo === 16 ? 'warning' : 'success',
                    solid: true,
                    autoHideDelay: 4000
                });

                // Recargar la tabla
                await this.misSolicitudes();

            } catch (error) {
                console.error("Error al procesar el retiro:", error);
                
                let mensajeError = 'Ocurrió un error al procesar el retiro. Por favor intente nuevamente.';
                if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
                    mensajeError = error.response.data.error.message;
                }
                
                this.$bvToast.toast(mensajeError, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 5000
                });
            } finally {
                // Desactivar loading siempre al finalizar
                this.loadingRetiroProveedor = false;
            }
        },

        // MÉTODO LEGACY - Mantenerlo para compatibilidad (deprecado)
        async confirmarRetiroProveedor(id) {
            try {
                const fecha = Date.now();
                const dia = new Date(fecha);
                
                // Convertir datetime-local a ISO string para retiro efectivo
                let fechaRetiroFormateada = null;
                if (this.fechaRetiroEfectivo) {
                    const fechaRetiro = new Date(this.fechaRetiroEfectivo);
                    fechaRetiroFormateada = fechaRetiro.toISOString();
                }

                // Realizar la actualización del estado a 13 (Retirado)
                const response = await clientes.putEstadosSolicitudes({
                    "nombre_entidad": this.nombreEntidad,
                    "id_metadata": id,
                    "id_version": this.idVersion,
                    "estado": 13,
                    "fecha_retiro_efectivo": fechaRetiroFormateada,
                    "observaciones": this.notaadicional
                });

                console.log("Respuesta de cambio de estado a Retirado:", response);

                // Guardar las imágenes adjuntas si existen
                this.guardarImagen(id, 'retiro_efectivo');

                // Limpiar los campos
                this.notaadicional = "";
                this.fechaRetiroEfectivo = null;

                // Cerrar el modal
                this.$refs['modal-retiro-proveedor'].hide();

                // Mostrar mensaje de éxito
                this.$bvToast.toast('El estado de la solicitud ha sido actualizado a "Retirado" exitosamente.', {
                    title: 'Retiro Confirmado',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 3000
                });

                // Recargar la tabla
                this.misSolicitudes();

            } catch (error) {
                console.error("Error al confirmar el retiro:", error);
                this.$bvToast.toast('Ocurrió un error al confirmar el retiro. Por favor intente nuevamente.', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 5000
                });
            }
        },
        
        async Asignarsolicitud(id) {
            const fecha = Date.now();
            // const dia = fecha.getDate() + "/" + (fecha.getMonth() +1) + "/" + fecha.getFullYear();
            const dia = new Date(fecha);
            console.log("fecha hoyyy", dia.toISOString());

            

            if (this.botonmodal == 'Aceptar') {
                // Verificar el estado actual de la solicitud antes de asignar (prevenir asignación duplicada por datos desactualizados en el navegador)
                try {
                    const datosActuales = await clientes.consultaEntidadById({
                        nombre_entidad: this.nombreEntidad,
                        id_metadata: id
                    });
                    if (datosActuales && datosActuales.length > 0 && datosActuales[0].data) {
                        const estadoActual = datosActuales[0].data.estado;
                        const proveedorActual = datosActuales[0].data.id_proveedor;
                        if (estadoActual == 3 && (proveedorActual !=0 && proveedorActual != null)) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Solicitud ya asignada',
                                text: 'Esta solicitud ya tiene un proveedor asignado y se encuentra en estado "En Solicitud". No es posible realizar otra asignación.',
                                confirmButtonText: 'Entendido',
                                confirmButtonColor: '#f0ad4e'
                            });
                            return;
                        }
                    }
                } catch (errVerificacion) {
                    console.warn('[asignacion] No se pudo verificar el estado actual de la solicitud:', errVerificacion);
                }

                if (this.Aprovedor == 'true') {
                    const response = await clientes.putEstadosSolicitudes({
                        "nombre_entidad": this.nombreEntidad,
                        "id_metadata": id,
                        "id_version": this.idVersion,
                        "estado": 3,
                        "id_proveedor": parseInt(this.proveedorId),
                        "id_prestador": 5,
                        "fecha_asignacion": dia,
                        "observaciones":this.notaadicional
                    })
                    this.notaadicional="";
                } else {
                    const response = await clientes.putEstadosSolicitudes({
                        "nombre_entidad": this.nombreEntidad,
                        "id_metadata": id,
                        "id_version": this.idVersion,
                        "estado": 3,
                        "id_prestador": 5,
                        "fecha_asignacion": dia,
                        "observaciones":this.notaadicional
                    })
                    this.notaadicional="";
                }
                this.guardarImagen(id,'solicitud');
                // Liberar el bloqueo al confirmar la asignación
                try { await clientes.desbloquearSolicitud(id); } catch(e) { console.warn('[bloqueo] No se pudo liberar:', e); }
                this.$delete(this.bloqueos, id);
                this.idSolicitud = null; // nullear antes de hide para que onCerrarModalAsignacion no repita la liberación
                this.misSolicitudes();
                this.$refs['modal-6'].hide()
            } else {
                // Liberar el bloqueo si el usuario cancela sin confirmar
                const idParaLiberar = this.idSolicitud;
                this.idSolicitud = null; // nullear antes de hide para que onCerrarModalAsignacion no repita la liberación
                try { await clientes.desbloquearSolicitud(idParaLiberar); } catch(e) { console.warn('[bloqueo] No se pudo liberar:', e); }
                this.$delete(this.bloqueos, idParaLiberar);
                this.$refs['modal-6'].hide()
            }


        },
        hideModal() {

            this.filterByColum1 = null;
            this.filter1 = "";
            this.fechainicio1 = "";
            this.fechafinal1 = "";
            this.$refs['modal-1'].hide()
            this.$refs['modal-2'].hide()
            this.$refs['modal-3'].hide()
              
            this.misSolicitudes();
        },
        async onCerrarModalDetalle() {
            // Solo liberar si el lock fue adquirido y el usuario NO navegó al detalle
            if (this._bloqueoDetalleActivo && this.idSolicitud) {
                try {
                    await clientes.desbloquearSolicitud(this.idSolicitud);
                } catch (e) {
                    console.warn('[bloqueo] No se pudo liberar al cerrar modal-9:', e);
                }
                this.$delete(this.bloqueos, this.idSolicitud);
                this._bloqueoDetalleActivo = false;
            }
        },
        async onCerrarModalAsignacion() {
            // Se dispara cuando modal-6 se cierra (botón X u otras vías)
            // Si idSolicitud ya fue nulleado por Asignarsolicitud, el bloqueo ya fue liberado — no hacer nada
            if (this.idSolicitud) {
                try {
                    await clientes.desbloquearSolicitud(this.idSolicitud);
                } catch (e) {
                    console.warn('[bloqueo] No se pudo liberar al cerrar modal:', e);
                }
                this.$delete(this.bloqueos, this.idSolicitud);
                this.idSolicitud = null;
            }
        },
        async guardarImagen(id_entidad,nombre_entidad) {
            if (this.files.length > 0) {
            const estructura = {
                "nombre_entidad": nombre_entidad,
                "id_entidad": id_entidad,
            };
            const formData = new FormData();
            formData.append('nombre_entidad', 'archivos'); 
            formData.append('estructura', JSON.stringify(estructura));
            
             Array.from(this.files).forEach((file) => {
                formData.append("entidad", file);
            });

            const response = await clientes.GuardarArchivosentidad(formData);

            this.files = "";
        }
        },
        formatearFecha(fechaString) {
            // Crear un objeto Date a partir de la cadena de fecha UTC
            const fechaUTC = new Date(fechaString);
            
            // Restar 10 horas para ajustar la zona horaria correctamente
            const fechaColombia = new Date(fechaUTC.getTime() - (5 * 60 * 60 * 1000));
            
            // Extraer los componentes de la fecha en UTC (ya ajustada con -10 horas)
            const año = fechaColombia.getUTCFullYear();
            const mes = this.agregarCero(fechaColombia.getUTCMonth() + 1);
            const dia = this.agregarCero(fechaColombia.getUTCDate());
            const hora = this.agregarCero(fechaColombia.getUTCHours());
            const minuto = this.agregarCero(fechaColombia.getUTCMinutes());

            let horas24 = fechaColombia.getUTCHours();
            let horas12 = horas24 % 12;
            horas12 = horas12 === 0 ? 12 : horas12;
            const horaFormateada = this.agregarCero(horas12);
            const ampm = horas24 >= 12 ? 'PM' : 'AM';
            
            // Formato: YYYY-MM-DD HH:MM
            const fechaFormateada = `${año}-${mes}-${dia} ${horaFormateada}:${minuto} ${ampm}`;
            
            return fechaFormateada;
        },

        // Función para formatear fecha con offset personalizado y formato AM/PM
        // Uso: this.formatearFechaConOffset(fecha, -5)  para Colombia
        //      this.formatearFechaConOffset(fecha, -10) para otros casos
        formatearFechaConOffset(fechaString, offsetHoras) {
        const fechaUTC = new Date(fechaString);
        const fechaAjustada = new Date(fechaUTC.getTime() + (offsetHoras * 60 * 60 * 1000));
        const año = fechaAjustada.getUTCFullYear();
        const mes = this.agregarCero(fechaAjustada.getUTCMonth() + 1);
        const dia = this.agregarCero(fechaAjustada.getUTCDate());
        let horas24 = fechaAjustada.getUTCHours();
        const minuto = this.agregarCero(fechaAjustada.getUTCMinutes());
        const ampm = horas24 >= 12 ? 'PM' : 'AM';
        let horas12 = horas24 % 12;
        horas12 = horas12 === 0 ? 12 : horas12;
        const horaFormateada = this.agregarCero(horas12);
        return `${año}-${mes}-${dia} ${horaFormateada}:${minuto} ${ampm}`;
        },

        // Función auxiliar para agregar cero a números menores que 10
        agregarCero(numero) {
            return numero < 10 ? '0' + numero : numero;
        },

        // ===== MÉTODOS PARA DIVIDIR SOLICITUD =====
        async abrirModalDividir(solicitud) {
            try {
                this.errorDivision = '';
                this.procesandoDivision = false; // Reset flag
                this.solicitudADividir = solicitud;
                
                // Obtener los detalles completos de la solicitud
                const response = await clientes.consultaEntidadById({
                    nombre_entidad: this.nombreEntidad,
                    id_metadata: solicitud.id
                });

                console.log('Response consultaEntidadById:', response);

                // La API devuelve un array directamente: [{data: {...}}]
                if (response && response.length > 0 && response[0].data) {
                    const dataSolicitud = response[0].data;
                    
                    console.log('dataSolicitud:', dataSolicitud);
                    console.log('elementos:', dataSolicitud.elementos);
                    console.log('elementos_institucion:', dataSolicitud.elementos_institucion);
                    
                    // Extraer elementos
                    this.elementosSolicitud = dataSolicitud.elementos || [];
                    this.elementosInstitucionSolicitud = dataSolicitud.elementos_institucion || [];
                    
                    // Validar que tenga al menos 2 elementos en total para poder dividir
                    const totalElementos = this.elementosSolicitud.length + this.elementosInstitucionSolicitud.length;
                    
                    if (totalElementos <= 1) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'No se puede dividir',
                            text: 'La solicitud debe tener al menos 2 elementos para poder dividirse',
                            confirmButtonText: 'Entendido'
                        });
                        return;
                    }
                    
                    // Resetear divisiones
                    this.divisiones = [
                        { nombre: 'División 1', elementos: [], elementos_institucion: [] }
                    ];
                    
                    this.$refs['modal-dividir'].show();
                } else {
                    console.error('Estructura de respuesta inesperada:', response);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo obtener la información de la solicitud'
                    });
                }
            } catch (error) {
                console.error('Error al abrir modal dividir:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al cargar la solicitud'
                });
            }
        },

        cerrarModalDividir() {
            this.solicitudADividir = null;
            this.elementosSolicitud = [];
            this.elementosInstitucionSolicitud = [];
            this.divisiones = [
                { nombre: 'División 1', elementos: [], elementos_institucion: [] }
            ];
            this.errorDivision = '';
        },

        agregarDivision() {
            const numeroDivision = this.divisiones.length + 1;
            this.divisiones.push({
                nombre: `División ${numeroDivision}`,
                elementos: [],
                elementos_institucion: []
            });
        },

        eliminarDivision(index) {
            if (this.divisiones.length > 1 && index > 0) {
                this.divisiones.splice(index, 1);
                // Renombrar las divisiones restantes
                this.divisiones.forEach((div, idx) => {
                    div.nombre = `División ${idx + 1}`;
                });
            }
        },

        getOpcionesElementos(elementos) {
            // Convertir elementos a opciones para checkbox group
            return elementos.map((elem, idx) => {
                const id = elem.id || elem;
                const nombre = elem.nombre || elem.name || this.obtenerNombreElemento(id) || `Elemento ${idx + 1}`;
                return {
                    text: nombre,
                    value: id
                };
            });
        },

        validarDivisiones() {
            // Validar que TODAS las divisiones tengan al menos un elemento
            for (let i = 0; i < this.divisiones.length; i++) {
                const div = this.divisiones[i];
                if (div.elementos.length === 0 && div.elementos_institucion.length === 0) {
                    this.errorDivision = `La ${div.nombre} debe tener al menos un elemento. Elimínela si no la necesita.`;
                    return false;
                }
            }

            // Validar que no haya elementos repetidos entre divisiones
            const todosElementos = [];
            const todosElementosInstitucion = [];
            
            for (const div of this.divisiones) {
                for (const elem of div.elementos) {
                    if (todosElementos.includes(elem)) {
                        this.errorDivision = 'Un elemento no puede estar en múltiples divisiones';
                        return false;
                    }
                    todosElementos.push(elem);
                }
                
                for (const elem of div.elementos_institucion) {
                    if (todosElementosInstitucion.includes(elem)) {
                        this.errorDivision = 'Un elemento no puede estar en múltiples divisiones';
                        return false;
                    }
                    todosElementosInstitucion.push(elem);
                }
            }
            
            this.errorDivision = '';
            return true;
        },

        async dividirSolicitud() {
            // Prevenir múltiples clics
            if (this.procesandoDivision) {
                console.warn('⚠️ División ya en proceso, ignorando click adicional');
                return;
            }

            if (!this.validarDivisiones()) {
                return;
            }

            this.procesandoDivision = true;
            console.log('🔄 Iniciando división de solicitud...');

            try {
                // Preparar las divisiones para enviar al backend
                const divisionesParaEnviar = this.divisiones.map(div => ({
                    elementos: div.elementos,
                    elementos_institucion: div.elementos_institucion
                }));

                console.log('📤 Enviando al backend:', {
                    id_solicitud: this.solicitudADividir.id,
                    cantidad_divisiones: divisionesParaEnviar.length,
                    divisiones: divisionesParaEnviar
                });

                const response = await clientes.dividirSolicitud({
                    id_solicitud: this.solicitudADividir.id,
                    divisiones: divisionesParaEnviar
                });

                console.log('📥 Respuesta del backend:', response);

                if (response && !response.error) {
                    // Separar solicitud original de las nuevas
                    const solicitudesNuevas = response.data.solicitudes_creadas.filter(s => !s.es_original);
                    const solicitudOriginal = response.data.solicitudes_creadas.find(s => s.es_original);
                    
                    let mensajeHTML = `<p><strong>Solicitud original #${response.data.solicitud_original}:</strong> Actualizada con ${solicitudOriginal.elementos.length + solicitudOriginal.elementos_institucion.length} elemento(s) de la División 1</p>`;
                    
                    if (solicitudesNuevas.length > 0) {
                        mensajeHTML += `<p><strong>Nuevas solicitudes creadas:</strong></p>
                            <ul style="text-align: left;">
                                ${solicitudesNuevas.map((s, index) => 
                                    `<li>Solicitud #${s.id} con ${s.elementos.length + s.elementos_institucion.length} elemento(s) (División ${index + 2})</li>`
                                ).join('')}
                            </ul>`;
                    }
                    
                    Swal.fire({
                        icon: 'success',
                        title: '¡División exitosa!',
                        html: mensajeHTML,
                        timer: 6000
                    });
                    this.$refs['modal-dividir'].hide();
                    this.procesandoDivision = false; // Reset flag
                    this.misSolicitudes(); // Recargar la tabla
                } else {
                    this.procesandoDivision = false; // Reset flag
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.error?.message || 'No se pudo dividir la solicitud'
                    });
                }
            } catch (error) {
                this.procesandoDivision = false; // Reset flag
                console.error('Error al dividir solicitud:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.message || 'Ocurrió un error al dividir la solicitud'
                });
            }
        }

    }
};
</script>
<style>
.b-imagenss{
    margin:2%;
    padding:1%;
    background-color: #f5f5f5;
    cursor: pointer;
}
.obligatorio{
    color: red;
    float: left;
    display: flex;
    margin-top: -13%;
    margin-left: -2%;
}
.botonopciones {
    width: 100%;
    font-size: 12px !important;
}

.iconoopcione {
    zoom: 2;
}

.centrar {
    text-align: center;
    padding: 5%;
}

.spinerr {
    padding: 5% 0%;
    margin-top: 2%;
    margin-bottom: 1%;
    text-align: center;
}

.opcionesasignar {
    margin-top: 2% !important;
    margin-bottom: 1%;
}

.opcionesprove {
    margin-bottom: 4%;
}
.letraImage{
    color: #000;
}
.opcionesretiro {
    margin-top: 3%;
    margin-bottom: 2%;
}

.departs p {
    text-transform: lowercase;
}
.alerts{
    margin-top: 2%;
}
.departs p:first-letter {
    text-transform: uppercase;
}

.breadcrumb {
    margin: 1% 0%;
}

.listamotivo {
    margin-top: 3%;
}

.aceptarrechazo {
    margin-top: 16%;
}

.iconoexcel {
    margin-right: 6%;
}

.botonexcel {
    width: 144px !important;
}

.chequeo {
    margin-top: 1%;
    margin-bottom: 1%;
}

.descargarexcel {
    position: absolute;
    right: 15%;
    top: 22%;
}

.divnodata {
    text-align: center;
    color: grey;
    font-weight: 800;
}

.bannernodata {
    width: 20%;
}

.nombrelabel {
    padding-top: 0.5%;
}

.selectpage {
    margin-bottom: 1%;
}

.thead-light {
    font-size: 15px !important;
}

#my-tablems {
    margin-top: 2% !important;
}

.rowhistorial {
    margin-top: 2% !important;
}

.close {
    color: gray;
}

.modal-content {
    width: 100% !important;
    padding: 3%;
}

/* .modal-dialog {
    width: 80% !important;
    max-width: 80% !important;
} */

.modal-contents {
    padding: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background-color: #5460B5 !important;
}

.modalSolicitudes {
    width: 100% !important;
}

.modal-historico-estados {
    max-width: 97% !important;
    width: 97% !important;
}

.modal-historico-estados #my-table2 td,
.modal-historico-estados #my-table2 th {
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
}

#my-table {
    margin-top: 2%;
}

#my-table2 {
    margin-top: 2%;
}

.boton-busccar {
    width: 100%;
    height: 38px !important;
}

.iconobuscar {
    zoom: 1;
}

.butonver {
    --background: var(--verde) !important;
}

.custom-th {
    font-weight: 800;
}

.butonopcionesMS {
    background: var(--blue-violet-2) !important;
    margin-bottom: 1%;
    margin-top: 1%;
    border: 1px solid var(--blue-violet-2) !important;
    color: white;
    font-weight: 800;
}

.butonopcionesMS:hover {
    background: var(--hover2) !important;
    margin-bottom: 1%;
    margin-top: 1%;
    color: white;
}

/* Posicionar el botón X de cierre en la esquina superior derecha del modal */
.modal-header {
    position: relative;
}

.modal-header .close {
    position: absolute !important;
    top: 10px !important;
    right: 15px !important;
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
    font-size: 2rem !important;
    font-weight: 700 !important;
    line-height: 1 !important;
    color: #000 !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    cursor: pointer !important;
    z-index: 1000 !important;
}

.modal-header .close:hover {
    color: #666 !important;
    opacity: 0.8 !important;
}

.modal-header .close:focus {
    outline: none !important;
}
</style>